/*
Rajesh 11/15/2022 2699292412 Added Add task form.
Rajesh 11/15/2022 2699292412 Added Report Code field and search report master.
Rajesh 11/16/2022 2699292412 Added data for add task table.
Rajesh 11/17/2022 2699292412 reworked on the fields for run report.
Prakash 11/18/2022 2699292412 Design Enhancements For Task Type Fields.
akhila 11/18/2022 2699292412 fixed taskcode issue.
Rajesh 11/18/2022 2699292412 worked on initial values and trigger group fields.
akhila 11/18/2022 2699292412 fixed data prepopulation issues.
akhila 11/18/2022 2699292412  added execution icon
akhila 11/19/2022 2699292412  fixed data prepopulation issues.
akhila 11/19/2022 2699292412 fixed trigger group prepopulation issue
SaiKrishna 11/21/2022 2699217591 Revamped pre population and payload code
SaiKrishna 11/22/2022 2699217591 Add task issues and payload changes done
SaiKrishna 11/23/2022 2699217591 Dynamic fields prepopulation, access method fields rendering bugs and some bugs fixed.
Suresh Peddavoora 11/23/2022 3225736869 Alignments for textfields Validation Messages Fixed.
SaiKrishna 11/23/2022 2699217591 Fixed multiple payload bugs and task code dynamic validation.
Saikrishna 11/24/2022 2699217591 Added validations to dynamic fields
Ashraf 11/24/2022 2699217591 passing props to dynamic fields
Akhila 11/25/2022 2699292412 change filter method field drop-down only description
Suresh Peddavoora 11/25/2022 2699217591 Fixed Multiselect Dropdown Alignment Issues.
Rajesh 11/25/2022 2699217591 fixed validation issues and action default value
ajesh 11/25/2022 2699217591 report output format validation message change
Dilip 11/28/2022 2699217591 added unsave alert popup
lalitha 11/28/2022 2699217591  disabled Batch Trigger group field after selecting Task Type
Dilip 11/30/2022 2699217591 added required validation for condition field
Rajesh 01/12/2022 2699217591 added suggestion dropdown  for taskcode and end date validation
akhila 04/12/2022 2699217591 added skipOnCompletion defaultvalue No
Sai Maheshwar 12/04/2022 2699217591 renamed form field label
Dilip 12/05/2022  2699217591 Removed unecesarry console.log statements
lalitha 12/06/2022 2699217591 renamed Task Code in validation
akhila 12/06/2022 2699217591 fixed starDate and endDate payload issues
Saikrishna 12/18/2022 3225736869 Fixed jira bugs by QA on night jobs
akhila 12/22/2022 3225736869 fixed emails comma separate issue
akhila 12/23/2022 3225736869 fixed reset issue
Ashraf 12/26/2022 3225736869 fixed on touch date validation issue
akhila 12/26/2022 3225736869 fixed reset issue
Ashraf 12/28/2022 3225736869 renamed show dashboard to show work queue list
Dilip 12/30/2022 3225736869 renamed field labels
Ashraf 01/02/2023 3225736869 fixed add task submit issue
Ashraf 01/02/2022 3225736869 fixed page break issue
Rohini 01/06/2023 3225736869 fixed alignments for textfield
Ashraf 01/06/2022 3225736869 fixed action greater than(>) date value
Akhila 02/01/2023 3225736869 invalid validation issue in date field bug fixed
Sohel 02/13/2022 2692790263 roles dropdown issue
Prakash 02/17/2023 3225736869 Added class for Multiselect Label Component.
suresh peddavoora 02/22/2023 3225736869 New UI changes fixed
Raghu 02/27/2023 3225736869 added new class for buttons
suresh peddavoora 03/06/2023 3225736869 New UI changes
suresh peddavoora 03/10/2023 3225736869 New UI changes
Ravi 03/30/2023 3225736869 updated the payload and fixed validation issue
Akhila 03/31/2023 3225736869 Added letter group field and condition
Guru Prasad 04/03/2023 3225736869 fixed columns issues conditionally
suresh peddavoora 04/05/2023 3225736869 fixed fields alignments
Prakash 04/07/2023 3225736869 fixed alignemnts isse in tab view.
Sohel 04/08/2023 3225736869 Schedular Added Letter Type Dropdown and Letter Group API changes
Sohel 04/08/2023 3225736869 Fixed Validation Issue in Scheduler
Sohel 04/08/2023 3225736869 Fixed populate issue
Sohel 04/10/2023 3225736869 Fixed Letter Type Payload Changes
Prakash 13/04/2023 3225736869 remove margin top
Prakash 26/04/2023 3225736869 fixed button color issue
Prakash 26/04/2023 3225736869 fixed button spacing issue
Akhila 04/27/2023 3225736869 Added popOver funtionality in report code field and trigger code field
Akhila 04/27/2023 3225736869 modified popOver funtionality in report code field and trigger code field
Prakash 5/05/2023 3225736869 add theming color class name
Sohel 05/22/2023 3075154998 Added Imports and Exports in Schedular
Sohel 05/22/2023 3225736869 removed Client Code Validation
Sohel 05/23/2023 3075154998 Fixed Edit Id Issue
Sohel 05/23/2023 3075154998 Date Format Changes
Sohel 05/26/2023 3075154998 Change Client Number Payload
Sohel 06/09/2023 3075154998 Added between and not Between in Filter Methods
Suresh peddavoora 06/09/2023 3075154998 fixed textfield alignments
Sohel 06/09/2023 3075154998 Date Field Payload Changes
Sohel 06/09/2023 3075154998 Values Field Changes
Sohel 06/14/2023 3075154998 Fixed Add Task Reset Issue
Sohel 06/16/2023 2692790263 Added WorkQUeue in Add Task
Akhila 06/20/2023 2692790263 modified account by list date action and field implemented Today or T
Sohel 06/20/2023 2692790263 Fixed WorkQueue Code data Issue
Prakash 20/06/2023 2692790263 fixed alignmetns issuse  in tab view
Sohel 06/20/2023 2692790263 Fixed Trigger Group Reset Issue
Sohl 06/22/2023 2692790263 Fixed Schedular Bugs and Added Show Work Queue Filter Fields
Akhila 06/23/2023 2692790263 bug fixed TODAY date issue
Akhila 06/23/2023 2692790263 prepopulation issue fix for reposiotry and field name fields
Prakash 28/06/2023 2692790263 fixed ui bugs
Ravi 06/28/2023 2692790263 fixed prepopulate issue
Akhila 30/06/2023 2692790263 condtionaly label name change for folder path and file name
Akhila 07/03/2023 2692790263 bug fix start time and end time in export task type
Ravi 07/05/2023 2692790263 fixed prepopulate issue
Ravi 07/05/2023 2692790263 fixed save button issue
Sohel 10/16/2023 2698811066 Fixed Date Format issue
*/
import React, {useState, useContext, useEffect, useRef} from 'react';
import {Form, Formik} from 'formik';
import {
  Button,
  Checkbox,
  FormControl,
  FormHelperText,
  Grid,
  InputAdornment,
  makeStyles,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import {
  getFieldCode,
  postFieldCode,
  getActions,
  reportMasterUserName,
  reportMasterRoleName,
  getClientCodeData,
  getCollectorsData,
  fetchExistingReportCode,
  fetchExistingWorkQueueCode,
} from '../../../../../../redux/reducers/BRE/AddReportMaster';
import ErrorBoundaryForComponents from '../../../../../../util/ErrorBoundaryForComponents';
import * as Yup from 'yup';
import {useSelector} from 'react-redux';
import {Search, Clear} from '@material-ui/icons';
import DialogBox from '../../../../../../components/DialogBox';
import TriggerSearchTrigger from '../../../../Triggers/SearchTrigger/TriggerSearchForm';
import ReportMasterSearch from '../../../../ReportMaster/SearchReportMaster/ReportMasterSearch';
import {ArrowBack} from '@material-ui/icons';
import GetAccessMethodFields from '../../../../ReportMaster/SearchReportMaster/GetAccessMethodFields';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import {useDispatch} from 'react-redux';
import {
  FILE_TYPE,
  FIELD_SEPERATOR,
  EXPORT_FORMAT_TYPE,
} from '../../../../../../constants/Lookup';
import {
  fetchAdditionalInfo,
  getAllReportCodeData,
  resetReportMasterData,
} from '../../../../../../redux/reducers/ReportMaster';
import {getDropDownData} from '../../../../../../redux/reducers/BRE/AddRecordFormat';
import {getDropDownData as getDropDownDataDynamicFields} from '../../../../../../redux/reducers/BRE/AddReportMaster';
import {getFormattedDate} from '../../../../../../util/dateHelper';
import PageLoader from '../../../../../../components/PageLoader';
import SelectTabContextProvider from '../../../../../../components/SelectTabContext/SelectTabContext';
import GuiAutoComplete from '../../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';
import {
  fetchAllLetterGroupCode,
} from '../../../../../../redux/reducers/LetterMaintainance/NewLetterMaintenance';
import {
  getValueObject,
} from '../../../../../../util/GetDropdownObject';
import {LETTER_TYPE} from '../../../../../../constants/Lookup';
import {upperCaseName} from '../../../../../../components/UpperCaseCode';
import {
  fetchExistingBatchTriggerCode,
  fetchUserDefinedFields,
} from '../../../../../../redux/reducers/EventTactics/EventTactics';
// import {upperCaseCode} from '../../../../../../components/UpperCaseCode';
import ImportExportTaskForm from './ImportExportTaskForm';
import DataManagerSearch from '../../../../DataManager/DataManager/SearchDataManager/index';
import {getClientCodeDropDownData} from '../../../../../../redux/reducers/TriggerGroup';
import {
  fetchBasicInfoData,
  getExportFormatType,
  resetDataManager,
} from '../../../../../../redux/reducers/DataManager';
import WorkQueueSearch from '../../../../../Dashboard/WorkQueueMaintenance/WorkQueueSearch';
import AddFileName from '../../../../Reports/AddReport/StepperComponents/AddFileName';
import ReportFolderPath from '../../../../Reports/AddReport/StepperComponents/ReportFolderPath';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const useStyles = makeStyles((theme) => ({
  goBackBtn: {
    padding: '6px 12px',
    color: '#320469',
    marginBottom: '10px',
  },
  taskParameters: {
    border: '1px dashed',
    padding: '25px 10px 0px 10px',
    position: 'relative',
    marginBottom: '15px',
    borderRadius: '4px',
  },
  popUpValidation: {
    position: 'relative',
  },
}));
const TaskForm = ({
  setOpen,
  rowData,
  isEditMode,
  setTaskData,
  oldRuleCode,
  setIsEditMode,
  handleClose,
  taskData,
  setTask,
  rowEditData,
  editgetData,
}) => {
  const taskTypes = [
    {key: 'Trigger Group', value: 'Trigger Group'},
    {key: 'Run Report', value: 'Run Report'},
    {key: 'Letter Batches', value: 'Letter Batches'},
    {key: 'Imports', value: 'Imports'},
    {key: 'Exports', value: 'Exports'},
  ];
  const options = [
    {
      key: 'Yes',
      value: 'Y',
    },
    {
      key: 'No',
      value: 'N',
    },
  ];
  const displayHeaderData = [
    {key: 'Y', value: 'Yes'},
    {key: 'N', value: 'No'},
  ];
  const moduleType = [
    {key: 'Report', value: 'Report'},
    {key: 'WorkQueue', value: 'WorkQueue'},
  ];

  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const componentClasses = useStyles();
  const [currentRuleCode, setCurrentRuleCode] = useState(rowData?.taskCode || '');
  const [searchTrigger, setSearchTrigger] = useState(false);
  const [reportSearch, setReportSearch] = useState(false);
  const [reportSearchCode, setReportSearchCode] = useState();
  const [triggerSearchCode, setTriggerSearchCode] = useState({});
  const [reportData, setReportData] = useState({});
  const [triggerData, seTriggerData] = useState();
  const [fieldCodeValue, setFieldCodeValue] = useState({});
  const [fixedLength1, setFixedLength] = useState('');
  const [fieldSubmitted, setSubmitted] = useState(false);
  const [codePopover, setCodePopover] = useState(false);
  const [isCodeSearch, setIsCodeSearch] = useState(false);
  const {setSaveTab, setSample} =
    useContext(SelectTabContextProvider);
  const isActionChanged = useRef();
  const {additionalInfoData} = useSelector(({reportMaster}) => reportMaster);
  const {dropDownDataReportFormat} = useSelector(({addRecordFormat}) => ({
    dropDownDataReportFormat: addRecordFormat?.dropDownData,
  }));
  const {allLetterGroupCode, dropDownData: letterDropDownData} = useSelector(
    ({newLetterMaintenance}) => newLetterMaintenance,
  );
  const {basicInfoData, exportFormatTypeData} = useSelector(
    ({dataManagerGroup}) => dataManagerGroup,
  );
  const {allbatchTriggerData} = useSelector(({addEventTactic}) => addEventTactic);
  const {clientCodeDropdownData} = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const [DmtableData, setDmTableData] = useState({});
  const {
    isLoading,
    promptData,
    fieldCodeData,
    actionData,
    allRecordCodes,
    allWorkQueueCodes,
  } = useSelector(({addReportMaster}) => addReportMaster);
  const filteredfieldCodeData = fieldCodeData.filter((each) => each.fieldCode != 'DBUDWFIELDS');
  const codeRef = useRef();
  // const getReportsPopOverData = () => {
  //   if (allRecordCodes && allRecordCodes?.length > 0) {
  //     return allRecordCodes?.filter(
  //       (i) => String(i?.reportCode)?.startsWith(nameData) && i?.isActive === "Y"
  //     );
  //   } else {
  //     return [];
  //   }
  // };
  const [open1, setOpen1] = useState(false);
  const [folderPath, setFolderPath] = useState(false);

  const [nameData, setNameData] = useState();
  const [nameData1, setNameData1] = useState();
  const [namePopover, setNamePopover] = useState(false);
  const [namePopover1, setNamePopover1] = useState(false);
  const formRef = useRef();
  const dispatch = useDispatch();
  const {jobDetailsData, jobDataId} = useSelector(({addNightJob}) => addNightJob);
  const handleClose1 = () => {
    setOpen1(false);
    setFolderPath(false);
  };
  const getObject = (option, options) => {
    let label = {};
    const opt = option?.toLowerCase();
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (
          item?.fieldCode?.toLowerCase() === opt ||
          item?.key?.toLowerCase() === opt ||
          item?.value?.toLowerCase() === opt ||
          item?.valueCode?.toLowerCase() === opt ||
          item?.clientNumber?.toLowerCase() === opt
        ) {
          label = item;
        } else if (option === 'WQ') label = {key: 'WorkQueue', value: 'WorkQueue'};
      });
    return label;
  };
  const getReportData = (option, type) => {
    const data =
      type === 'Report' ? allRecordCodes : allWorkQueueCodes?.length > 0 ? allWorkQueueCodes : [];
    const label = {};
    data &&
      data.length > 0 &&
      data.forEach((item) => {
        if (item.reportCode === option) {
          setReportData(item);
        }
      });
    return label;
  };
  const getTriggerData = (option, options) => {
    const label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.groupCode === option) {
          seTriggerData(item);
        }
      });
    return label;
  };
  const getObjects = (option, typeCode) => {
    const options =
      dropDownDataReportFormat && dropDownDataReportFormat[typeCode] ?
        dropDownDataReportFormat[typeCode] :
        [];
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (
          item?.valueCode === option.toString() ||
          item.value?.toLowerCase() === option?.toLowerCase()
        ) {
          label = item;
        }
      });
    return label;
  };

  const getTaskType = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.value === option) {
          label = item;
        }
      });
    return label;
  };
  const dataManagerId = DmtableData?.dataManagerId ? DmtableData?.dataManagerId : '';
  const typeModule = formRef?.current?.values?.taskType?.value === 'Exports' ? 'Export' : 'Import';
  console.log(DmtableData, "DmtableDataDmtableData");
  useEffect(() => {
    if (dataManagerId) {
      dispatch(fetchBasicInfoData({dataManagerId: dataManagerId, tabType: typeModule}));
    }
  }, [dataManagerId]);

  const {userDefinedWindowData, userDefinedFieldsData} = useSelector(
    ({addEventTactic}) => addEventTactic,
  );
  useEffect(() => {
    if (reportData?.reportCode) {
      dispatch(fetchAdditionalInfo(reportData?.reportId));
    }
    dispatch(getDropDownData());
  }, [reportData?.reportCode]);

  useEffect(() => {
    dispatch(reportMasterUserName());
    dispatch(reportMasterRoleName());
    dispatch(getClientCodeData());
    dispatch(getDropDownDataDynamicFields());
    dispatch(fetchExistingReportCode());
    dispatch(fetchExistingWorkQueueCode());
    dispatch(getAllReportCodeData('WQ'));
    dispatch(fetchExistingBatchTriggerCode());
    dispatch(getCollectorsData());
    dispatch(getClientCodeDropDownData());
    setSaveTab(false);
  }, []);
  const getLetterGroupCodes = (user, allLetterGroupCode) => {
    return allLetterGroupCode?.filter((i) => user?.includes(i?.letterGroupCode));
  };
  const getClientCodes = (user, clientCodeData) => {
    return clientCodeData?.filter((i) => user?.includes(i?.clientNumber));
  };
  const initialValues1 = {
    taskCode: isEditMode && rowEditData?.taskCode ? rowEditData.taskCode : '',
    taskType:
      isEditMode && rowEditData?.taskType ? getTaskType(rowEditData?.taskType, taskTypes) : null,
    continuePrevTaskFailure:
      isEditMode && rowEditData?.continuePrevTaskFailure ?
        getObject(rowEditData?.continuePrevTaskFailure, options) :
        '',
    skipOnCompletion:
      isEditMode && rowEditData?.skipOnCompletion ?
        getObject(rowEditData?.skipOnCompletion, options) :
        {key: 'No', value: 'N'},
    reportCode:
      isEditMode && rowEditData?.taskReportParameterRequest?.reportCode ?
        rowEditData?.taskReportParameterRequest?.reportCode :
        '',
    module:
      isEditMode && rowEditData?.taskReportParameterRequest?.moduleName ?
        getObject(rowEditData?.taskReportParameterRequest?.moduleName, moduleType) :
        isEditMode && rowEditData?.taskReportParameterRequest?.module ?
          getObject(rowEditData?.taskReportParameterRequest?.module, moduleType) :
          {key: 'Report', value: 'Report'},
    reportId:
      isEditMode && rowEditData?.taskReportParameterRequest?.reportId ?
        rowEditData?.taskReportParameterRequest?.reportId :
        0,
    // groupCode: isEditMode && rowEditData.groupCode ? rowEditData.groupCode : "",
    triggerGroupCode:
      isEditMode && rowEditData?.taskTriggerGroupParameterRequest?.triggerGroupCode ?
        rowEditData?.taskTriggerGroupParameterRequest?.triggerGroupCode :
        '',
    triggerGroupParameterId:
      isEditMode && rowEditData?.taskTriggerGroupParameterRequest?.triggerGroupParameterId ?
        rowEditData?.taskTriggerGroupParameterRequest?.triggerGroupParameterId :
        '',
    reportParameterId:
      isEditMode && rowEditData?.taskReportParameterRequest?.reportParameterId ?
        rowEditData?.taskReportParameterRequest?.reportParameterId :
        '',
    displayHeader:
      isEditMode && rowEditData?.taskReportParameterRequest?.displayHeader ?
        getObject(rowEditData?.taskReportParameterRequest?.displayHeader, displayHeaderData) :
        '',

    endDate:
      isEditMode &&
      rowEditData?.taskReportParameterRequest?.accessMethodRequest?.accessMethod === 'DBLSTDTE' &&
      rowEditData?.taskReportParameterRequest?.accessMethodRequest?.lastDate ?
        getFormattedDate(rowEditData?.taskReportParameterRequest?.accessMethodRequest?.lastDate) :
        '',
    action:
      isEditMode && rowEditData?.taskType === 'Run Report' ?
        rowEditData?.taskReportParameterRequest?.accessMethodRequest?.action ?
          rowEditData?.taskReportParameterRequest?.accessMethodRequest?.action :
          '' :
        rowEditData?.taskTriggerGroupParameterRequest?.accessMethodRequest?.action ?
          rowEditData?.taskTriggerGroupParameterRequest?.accessMethodRequest?.action :
          '',
    startDate:
      isEditMode &&
      rowEditData?.taskReportParameterRequest?.accessMethodRequest?.accessMethod === 'DBLSTDTE' &&
      rowEditData?.taskReportParameterRequest?.accessMethodRequest?.startDate ?
        getFormattedDate(rowEditData?.taskReportParameterRequest?.accessMethodRequest?.startDate) :
        '',
    value:
      isEditMode && rowEditData?.taskType === 'Run Report' ?
        rowEditData?.taskReportParameterRequest?.accessMethodRequest?.value ?
          rowEditData?.taskReportParameterRequest?.accessMethodRequest?.value :
          '' :
        rowEditData?.taskTriggerGroupParameterRequest?.accessMethodRequest?.value ?
          rowEditData?.taskTriggerGroupParameterRequest?.accessMethodRequest?.value :
          '',
    accessMethod:
      isEditMode && rowEditData?.taskType === 'Run Report' ?
        rowEditData?.taskReportParameterRequest?.accessMethodRequest?.accessMethod ?
          getObject(
            rowEditData.taskReportParameterRequest?.accessMethodRequest?.accessMethod,
            fieldCodeData,
          ) :
          '' :
        rowEditData?.taskTriggerGroupParameterRequest?.accessMethodRequest?.accessMethod ?
          getObject(
            rowEditData.taskTriggerGroupParameterRequest?.accessMethodRequest?.accessMethod,
            fieldCodeData,
          ) :
          '',

    fieldSeparator:
      isEditMode && rowEditData.taskReportParameterRequest?.fieldSeparator ?
        getObject(
          rowEditData?.taskReportParameterRequest?.fieldSeparator,
          dropDownDataReportFormat?.FIELD_SEPERATOR,
        ) :
        '',
    reportFormat:
      isEditMode && rowEditData?.taskReportParameterRequest?.reportFormat ?
        getObjects(rowEditData.taskReportParameterRequest?.reportFormat, FILE_TYPE) :
        '',
    notifyError:
      isEditMode && rowEditData?.taskReportParameterRequest?.notifyErrorEmails ?
        rowEditData?.taskReportParameterRequest?.notifyErrorEmails?.join(',') :
        [],
    notifyCompletion:
      isEditMode && rowEditData?.taskReportParameterRequest?.notifyCompletionEmails ?
        rowEditData?.taskReportParameterRequest?.notifyCompletionEmails?.join(',') :
        [],
    taskId: isEditMode && rowEditData?.taskId > 0 ? rowEditData?.taskId : '',
    client: '',
    phase: '',
    collectors: '',
    disposition: '',
    outputFileNameReport:
      isEditMode && rowEditData?.taskReportParameterRequest?.reportOutputFileName ?
        rowEditData?.taskReportParameterRequest?.reportOutputFileName :
        '',
    reportpath:
      isEditMode && rowEditData?.taskReportParameterRequest?.reportfolderPath ?
        rowEditData?.taskReportParameterRequest?.reportfolderPath :
        '',
    letterGroupCode:
      isEditMode && rowEditData?.taskLetterGroupParameterRequest?.letterGroupCode?.length > 0 ?
        getLetterGroupCodes(
          rowEditData?.taskLetterGroupParameterRequest?.letterGroupCode,
          allLetterGroupCode,
        ) :
        [],
    letterType:
      isEditMode && rowEditData?.taskLetterGroupParameterRequest?.letterType ?
        getValueObject(
          rowEditData?.taskLetterGroupParameterRequest?.letterType,
          LETTER_TYPE,
          letterDropDownData,
        ) :
        [],
    outputFileName:
      isEditMode && rowEditData?.taskImportParameterRequest?.outputFileName ?
        rowEditData?.taskImportParameterRequest?.outputFileName :
        rowEditData?.taskExportParameterReqeust?.outputFileName ?
          rowEditData?.taskExportParameterReqeust?.outputFileName :
          '',
    reportpathDm:
      isEditMode && rowEditData?.taskImportParameterRequest?.folderPath ?
        rowEditData?.taskImportParameterRequest?.folderPath :
        rowEditData?.taskExportParameterReqeust?.folderPath ?
          rowEditData?.taskExportParameterReqeust?.folderPath :
          '',
    clientCode:
      isEditMode && ['Imports']?.includes(rowEditData?.taskType) ?
        getObject(rowEditData?.taskImportParameterRequest?.clientCode, clientCodeDropdownData) :
        isEditMode && ['Exports']?.includes(rowEditData?.taskType) ?
          getClientCodes(
            rowEditData?.taskExportParameterReqeust?.clientCode,
            clientCodeDropdownData,
          ) :
          '',
    dmCode:
      isEditMode && ['Imports']?.includes(rowEditData?.taskType) ?
        rowEditData?.taskImportParameterRequest?.importCode :
        isEditMode && ['Exports']?.includes(rowEditData?.taskType) ?
          rowEditData?.taskExportParameterReqeust?.exportCode :
          '',
    startTime:
      isEditMode && ['Exports']?.includes(rowEditData?.taskType) ?
        rowEditData?.taskExportParameterReqeust?.startDate.replace('cast(now()as date)', 'TODAY') :
        '',
    endTime:
      isEditMode && ['Exports']?.includes(rowEditData?.taskType) ?
        rowEditData?.taskExportParameterReqeust?.endDate.replace('cast(now()as date)', 'TODAY') :
        '',
    exportParameterId:
      isEditMode &&
      ['Exports']?.includes(rowEditData?.taskType) &&
      rowEditData?.taskExportParameterReqeust?.exportParameterId ?
        rowEditData?.taskExportParameterReqeust?.exportParameterId :
        0,
    importParameterId:
      isEditMode &&
      ['Imports']?.includes(rowEditData?.taskType) &&
      rowEditData?.taskImportParameterRequest?.importParameterId ?
        rowEditData?.taskImportParameterRequest?.importParameterId :
        0,
    exportFormat:
      isEditMode &&
      ['Exports']?.includes(rowEditData?.taskType) &&
      rowEditData?.taskExportParameterReqeust?.exportFormatType ?
        getValueObject(
          rowEditData?.taskExportParameterReqeust?.exportFormatType,
          EXPORT_FORMAT_TYPE,
          exportFormatTypeData,
        ) :
        0,
    clientIdPrompt:
      isEditMode &&
      ['Exports']?.includes(rowEditData?.taskType) &&
      rowEditData?.taskExportParameterReqeust?.clientIdPrompt ?
        rowEditData?.taskExportParameterReqeust?.clientIdPrompt :
        '',
    auditDatesPrompt:
      isEditMode &&
      ['Exports']?.includes(rowEditData?.taskType) &&
      rowEditData?.taskExportParameterReqeust?.auditDatesPrompt ?
        rowEditData?.taskExportParameterReqeust?.auditDatesPrompt :
        '',
  };
  const [initialValue, setInitialValue] = useState(initialValues1);
  useEffect(() => {
    if (fieldCodeData) {
      setInitialValue((prev) => ({
        ...prev,
        accessMethod:
          isEditMode && rowEditData?.taskType === 'Run Report' ?
            rowEditData?.taskReportParameterRequest?.accessMethodRequest?.accessMethod ?
              getObject(
                rowEditData.taskReportParameterRequest?.accessMethodRequest?.accessMethod,
                fieldCodeData,
              ) :
              '' :
            rowEditData?.taskTriggerGroupParameterRequest?.accessMethodRequest?.accessMethod ?
              getObject(
                rowEditData.taskTriggerGroupParameterRequest?.accessMethodRequest?.accessMethod,
                fieldCodeData,
              ) :
              '',
      }));
    }
  }, [fieldCodeData]);
  useEffect(() => {
    if (isEditMode && allLetterGroupCode) {
      setInitialValue((prev) => ({
        ...prev,
        letterGroupCode: getLetterGroupCodes(
          rowEditData?.taskLetterGroupParameterRequest?.letterGroupCode,
          allLetterGroupCode,
        ),
        letterGroupParameterId: rowEditData?.taskLetterGroupParameterRequest?.letterGroupParameterId ?
          rowEditData?.taskLetterGroupParameterRequest?.letterGroupParameterId :
          0,
      }));
    }
  }, [allLetterGroupCode]);
  useEffect(() => {
    if (isEditMode && rowEditData?.taskLetterGroupParameterRequest?.letterType) {
      const letterType = rowEditData?.taskLetterGroupParameterRequest?.letterType?.replace(' ', '_');
      dispatch(fetchAllLetterGroupCode(letterType));
    }
  }, [isEditMode, rowEditData]);
  const handleTaskReset = () => {
    setInitialValue(initialValues1);
  };
  const getValue = (values) => {
    const a = values?.split(' ')?.join('');
    const dateValue = values?.length > 1 ? values?.slice(0, 5) :'';
    if (dateValue?.toUpperCase() === 'TODAY') {
      return a?.replace(dateValue, 'cast(now()as date)');
    } else if (values?.charAt(0)?.toUpperCase() === 'T') {
      return a?.replace(values?.charAt(0), 'cast(now()as date)');
    } else {
      return values;
    }
  };
  useEffect(() => {
    let reportInitialValues = {};
    if (reportData) {
      reportInitialValues = {
        taskCode: formRef?.current?.values?.taskCode ? formRef?.current?.values?.taskCode : '',
        taskType: formRef?.current?.values?.taskType ? formRef?.current?.values?.taskType : '',
        continuePrevTaskFailure: formRef?.current?.values?.continuePrevTaskFailure ?
          formRef?.current?.values?.continuePrevTaskFailure :
          '',
        skipOnCompletion: formRef?.current?.values?.skipOnCompletion ?
          formRef?.current?.values?.skipOnCompletion :
          '',
        module: formRef?.current?.values?.module ? formRef?.current?.values?.module : '',
        reportCode: reportData?.reportCode ?
          reportData?.reportCode :
          initialValue?.reportSearchCode,
        accessMethod: reportData?.accessMethodInfo?.accessMethod ?
          getObject(reportData?.accessMethodInfo?.accessMethod, fieldCodeData) :
          initialValue?.accessMethod,
        action: reportData?.accessMethodInfo?.action ?
          reportData?.accessMethodInfo?.action :
          initialValue?.action,
        displayHeader: reportData?.displayHeader ?
          getObject(reportData?.displayHeader, displayHeaderData) :
          initialValue?.displayHeader,
        reportFormat: reportData?.reportFormat ?
          getObjects(reportData?.reportFormat, FILE_TYPE, dropDownDataReportFormat) :
          initialValue?.reportFormat,
        fieldSeparator: reportData?.fieldSeparator ?
          getObject(reportData?.fieldSeparator, dropDownDataReportFormat?.FIELD_SEPERATOR) :
          initialValue?.fieldSeparator,
        notifyError: reportData?.notifyErrorEmails ?
          reportData?.notifyErrorEmails?.join(',') :
          initialValue?.notifyError,
        notifyCompletion: reportData?.notifyCompletionEmails ?
          reportData?.notifyCompletionEmails?.join(',') :
          initialValue?.notifyCompletion,
      };
    }

    setInitialValue({...initialValue, ...reportInitialValues});
  }, [reportData]);

  useEffect(() => {
    let triggerInitialValues = {};
    if (triggerData) {
      triggerInitialValues = {
        taskCode: formRef?.current?.values?.taskCode ? formRef?.current?.values?.taskCode : '',
        taskType: formRef?.current?.values?.taskType ? formRef?.current?.values?.taskType : '',
        continuePrevTaskFailure: formRef?.current?.values?.continuePrevTaskFailure ?
          formRef?.current?.values?.continuePrevTaskFailure :
          '',
        skipOnCompletion: formRef?.current?.values?.skipOnCompletion ?
          formRef?.current?.values?.skipOnCompletion :
          '',

        triggerGroupCode: triggerData?.groupCode ?
          triggerData?.groupCode :
          initialValue?.triggerSearchCode,
        accessMethod: triggerData?.accessMethodInfo?.accessMethod ?
          getObject(triggerData?.accessMethodInfo?.accessMethod, fieldCodeData) :
          initialValue?.accessMethod,
        action: triggerData?.accessMethodInfo?.action ?
          triggerData?.accessMethodInfo?.action :
          initialValue?.action,
      };
    }

    setInitialValue({...initialValue, ...triggerInitialValues});
  }, [triggerData]);

  const resetTaskParameters = () => {
    const resetTaskParametersValues = {
      taskCode: formRef?.current?.values?.taskCode ? formRef?.current?.values?.taskCode : '',
      taskType: formRef?.current?.values?.taskType ? formRef?.current?.values?.taskType : '',
      continuePrevTaskFailure: formRef?.current?.values?.continuePrevTaskFailure ?
        formRef?.current?.values?.continuePrevTaskFailure :
        '',
      skipOnCompletion: formRef?.current?.values?.skipOnCompletion ?
        formRef?.current?.values?.skipOnCompletion :
        '',
      triggerGroupParameterId: formRef?.current?.values?.triggerGroupParameterId ?
        formRef?.current?.values?.triggerGroupParameterId :
        '',
      reportParameterId: formRef?.current?.values?.reportParameterId ?
        formRef?.current?.values?.reportParameterId :
        '',

      triggerGroupCode: '',
      accessMethod: '',
      action: '',
      displayHeader: '',
      reportFormat: '',
      fieldSeparator: '',
      notifyError: [],
      notifyCompletion: [],
      reportCode: '',
      module: {key: 'Report', value: 'Report'},
      letterGroupCode: [],
      outputFileNameReport: [],
      reportpath: [],
      reportpathDm: [],
      outputFileName: [],
      clientCode: [],
      dmCode: '',
      startTime: '',
      endTime: '',
    };
    setInitialValue({...initialValue, ...resetTaskParametersValues});
  };
  function getOptionsRecordFormatDropDown(typeCode) {
    let label = [];
    label =
      dropDownDataReportFormat && dropDownDataReportFormat[typeCode] ?
        dropDownDataReportFormat[typeCode] :
        [];

    return label;
  }
  const checkTaskCodeExist = (val) => {
    const currTaskCodes = taskData?.map((each) => each?.taskCode);
    if (currTaskCodes.includes(val)) {
      return true;
    }
    return false;
  };
  const getTaskCodesData = () => {
    if (taskData && taskData?.length > 0) {
      return taskData?.filter((i) => String(i?.taskCode)?.startsWith(currentRuleCode));
    } else {
      return [];
    }
  };
  const schema = Yup.object().shape({
    taskCode:
      rowData?.taskCode === currentRuleCode && isEditMode ?
        '' :
        Yup.string()
          .required('Task Code is required')
          .matches(/^[a-zA-Z0-9]+$/, 'White space and special character are not allowed')
          .required('Task Code is required')
          .test('taskCode', 'Task Code already exists', (value) => !checkTaskCodeExist(value)),
    taskType: Yup.object()
    // .notOneOf(["none"], "Task type is required")
      .required('Task Type is required')
      .nullable(),
    // skipOnCompletion"continuePrevTaskFailure
    skipOnCompletion: Yup.object()
    // .notOneOf(["none"], "Skip on completion is required")
      .required('Skip on completion is required')
      .nullable(),
    continuePrevTaskFailure: Yup.object()
    // .notOneOf(["none"], "Continue prev task failure is required")
      .required('Continue on task failure is required')
      .nullable(),
    disposition:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DSDISP' &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) &&
      Yup.array().test('dispo', 'Status is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    // .notOneOf(["none"], "Continue prev task failure is required")
    // .required("Disposition is required")
    // .nullable(),
    collectors:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBCOLLECTOR' &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) &&
      Yup.array().test('collector', 'Collector is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    phase:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DSSTAT' &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) &&
      Yup.array().test('phase', 'Phase is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    client:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBCLNT' &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) &&
      Yup.array().test('client', 'Client is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    Date:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBLSTDTE' &&
      ['<', '>'].includes(formRef?.current?.values?.action) &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) &&
      // Yup.date().typeError("Invalid Date Format").nullable().required("Date is required"),
      Yup?.mixed().test('Date', 'Values is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    startDate:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBLSTDTE' &&
      ['Between'].includes(formRef?.current?.values?.action) &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) &&
      // Yup.date().typeError("Invalid Date Format").nullable().required("Start date is required"),
      Yup.mixed().test('startDate', 'From Values is required', (val) => {
        if (!val) {
          return false;
        } else {
          return true;
        }
      }),
    lastDate:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBLSTDTE' &&
      ['Between'].includes(formRef?.current?.values?.action) &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) &&
      // Yup.date()
      //   .typeError("Invalid Date Format")
      //   .nullable()
      //   .required("End date is required")
      //   .min(Yup.ref("startDate"), "End date should be greater than start date"),
      Yup.mixed().test('lastDate', 'To Values is required', (val) => {
        if (!val) {
          return false;
        } else {
          return true;
        }
      }),
    action:
      formRef?.current?.values?.accessMethod?.fieldCode !== 'DBACCT' &&
      !['Letter Batches', 'Imports', 'Exports']?.includes(
        formRef?.current?.values?.taskType?.value,
      ) &&
      Yup.string()
      // .notOneOf(["none"], "Continue prev task failure is required")
        .required('Action is required')
        .nullable(),
    fieldSeparator:
      formRef?.current?.values?.taskType?.value === 'Run Report' &&
      Yup.object()
      // .notOneOf(["none"], "Field separator is required")
        .required('Field separator is required')
        .nullable(),
    displayHeader:
      formRef?.current?.values?.taskType?.value === 'Run Report' &&
      Yup.object()
      // .notOneOf(["none"], "Display header is required")
        .required('Display header is required')
        .nullable(),
    reportFormat:
      formRef?.current?.values?.taskType?.value === 'Run Report' &&
      Yup.object()
      // .notOneOf(["none"], "Report format is required")
        .required('Report output format is required')
        .nullable(),
    accessMethod:
      !['Letter Batches', 'Imports', 'Exports']?.includes(
        formRef?.current?.values?.taskType?.value,
      ) &&
      Yup.object()
      // .notOneOf(["none"], "Filter method is required")
        .required('Filter method is required')
        .nullable(),
    reportCode: isEditMode ?
      null :
      formRef?.current?.values?.taskType?.value === 'Run Report' &&
        Yup.string()
          .required(
                `${
              formRef?.current?.values?.module?.value === 'Report' ? 'Report' : 'WorkQueue'
                } Name is required`,
          )
          .nullable()
          .test(
            'reportCode',
                `${
              formRef?.current?.values?.module?.value === 'Report' ? 'Report' : 'WorkQueue'
                } Code not available`,
                (value, ctx) => {
                  const data =
                ctx.parent?.module?.value === 'Report' ?
                  allRecordCodes :
                  allWorkQueueCodes?.length > 0 ?
                    allWorkQueueCodes :
                    [];
                  const newRecordData = data.map((el) => el.reportCode);
                  if (newRecordData.includes(value)) {
                    return true;
                  } else {
                    return false;
                  }
                },
          ),
    module:
      formRef?.current?.values?.taskType?.value === 'Run Report' ?
        Yup.mixed().test('moduleType', 'Module Type  is required', (value) => {
          if (!value?.value) {
            return false;
          } else {
            return true;
          }
        }) :
        null,
    triggerGroupCode:
      formRef?.current?.values?.taskType?.value === 'Trigger Group' &&
      Yup.string()
        .required('Batch Trigger group is required')
        .nullable()
        .test('triggerGroupCode', 'Batch Trigger not available', (value) => {
          const newRecordData = allbatchTriggerData.map((el) => el.groupCode);
          if (newRecordData.includes(value)) {
            return true;
          } else {
            return false;
          }
        }),
    notifyCompletion:
      formRef?.current?.values?.taskType?.value === 'Run Report' &&
      Yup.mixed().test('notifyCompletion', 'Invalid Emails ', (value) => {
        if (value?.length) {
          const modifiedValue = value?.split(',');
          const reqArr =
            modifiedValue && modifiedValue?.length > 0 ?
              modifiedValue?.filter((each) => each?.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) :
              [];
          if (reqArr?.length === modifiedValue?.length) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      }),
    notifyError:
      formRef?.current?.values?.taskType?.value === 'Run Report' &&
      Yup.mixed().test('notifyCompletion', 'Invalid Emails ', (value) => {
        if (value?.length) {
          const modifiedValue = value?.split(',');
          const reqArr =
            modifiedValue && modifiedValue?.length > 0 ?
              modifiedValue?.filter((each) => each?.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g)) :
              [];
          if (reqArr?.length === modifiedValue?.length) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      }),
    repoitoryName:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
      formRef?.current?.values?.taskType?.value === 'Run Report' &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) &&
      Yup.mixed().required('Repository Name is required').nullable(),
    fieldsName:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
      formRef?.current?.values?.taskType?.value === 'Run Report' &&
      !['Is Blank', 'Is Not Blank']?.includes(formRef?.current?.values?.action) &&
      Yup.mixed().required('Field Name is required').nullable(),
    letterGroupCode:
      formRef?.current?.values?.taskType?.value === 'Letter Batches' ?
        Yup.array().test('letterGroup', 'Letter Group is required', (val, ctx) => {
          if (val?.length) {
            return true;
          } else {
            return false;
          }
        }) :
        null,
    letterType:
      formRef?.current?.values?.taskType?.value === 'Letter Batches' ?
        Yup.mixed().test('LetterType', 'Letter Type  is required', (value, ctx) => {
          if (!value?.value) {
            return false;
          } else {
            return true;
          }
        }) :
        null,
    startTime:
      formRef?.current?.values?.taskType?.value === 'Exports' &&
      ['Y'].includes(
        DmtableData?.auditDatesPrompt || rowEditData?.taskExportParameterReqeust?.auditDatesPrompt,
      ) ?
        Yup.mixed().test('startTime', 'Start date is required', (val) => {
          if (!val) {
            return false;
          } else {
            return true;
          }
        }) :
        null,
    endTime:
      formRef?.current?.values?.taskType?.value === 'Exports' &&
      ['Y'].includes(
        DmtableData?.auditDatesPrompt || rowEditData?.taskExportParameterReqeust?.auditDatesPrompt,
      ) ?
        Yup.mixed().test('endTime', 'End date is required', (val) => {
          if (!val) {
            return false;
          } else {
            return true;
          }
        }) :
        null,
    dmCode: ['Imports', 'Exports']?.includes(formRef?.current?.values?.taskType?.value) ?
      Yup.string().required(
          `${
            formRef?.current?.values?.taskType?.value === 'Exports' ? 'Export' : 'Import'
          } Manager Name required`,
      ) :
      '',
    exportFormat:
      formRef?.current?.values?.taskType?.value === 'Exports' ?
        Yup.mixed().test('exportFormat', 'Export Format Type is required', (value) => {
          if (!value?.value) {
            return false;
          } else {
            return true;
          }
        }) :
        null,
    toValues:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
      formRef?.current?.values?.taskType?.value === 'Run Report' &&
      ['BETWEEN', 'NOT BETWEEN']?.includes(formRef?.current?.values?.action) ?
        Yup.mixed().test('toValues', 'To Values is required', (val) => {
          if (!val) {
            return false;
          } else {
            return true;
          }
        }) :
        null,
    fromValues:
      formRef?.current?.values?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
      formRef?.current?.values?.taskType?.value === 'Run Report' &&
      ['BETWEEN', 'NOT BETWEEN']?.includes(formRef?.current?.values?.action) ?
        Yup.mixed().test('fromValues', 'From Values is required', (val) => {
          if (!val) {
            return false;
          } else {
            return true;
          }
        }) :
        null,
    reportpath: Yup.mixed().test(
      'reportpath',
        `Invalid Folder path, Can't contain // and \\`,
        function(value, context) {
          const regex = /^(?!.*\\|.*\/\/).*$/;
          const {parent} = context;
          if (regex.test(parent?.reportpath)) {
            return true;
          } else {
            return false;
          }
        },
    ),
    reportpathDm: Yup.mixed().test(
      'reportpathDm',
        `Invalid Folder path, Can't contain // and \\`,
        function(value, context) {
          const regex = /^(?!.*\\|.*\/\/).*$/;
          const {parent} = context;
          if (regex.test(parent?.reportpathDm)) {
            return true;
          } else {
            return false;
          }
        },
    ),
    outputFileName: ['Imports']?.includes(formRef?.current?.values?.taskType?.value) ?
      Yup.mixed().required('Imports File Name is required') :
      '',
  });
  useEffect(() => {
    setFixedLength(reportData?.fixedLength);
  }, [reportData]);
  function getOptions(typeCode) {
    let label = [];
    label =
      dropDownDataReportFormat && dropDownDataReportFormat[typeCode] ?
        dropDownDataReportFormat[typeCode] :
        [];

    return label;
  }

  const getReportsPopOverData = (type) => {
    const data =
      type === 'Report' ? allRecordCodes : allWorkQueueCodes?.length > 0 ? allWorkQueueCodes : [];
    if (data && data?.length > 0 && nameData) {
      return data?.filter((i) => String(i?.reportCode)?.startsWith(nameData));
    } else {
      return [];
    }
  };
  const getBatchTriggerPopOverData = () => {
    if (allbatchTriggerData && allbatchTriggerData?.length > 0 && nameData1) {
      return allbatchTriggerData?.filter((i) => String(i?.groupCode)?.startsWith(nameData1));
    } else {
      return allbatchTriggerData?.length > 0 ? allbatchTriggerData : [];
    }
  };

  const getLetterOptions = (typeCode) => {
    let label = [];
    label = letterDropDownData && letterDropDownData[typeCode] ? letterDropDownData[typeCode] : [];
    return label;
  };


  const getArrayData = (selectedAccessMethod, data) => {
    if (selectedAccessMethod === 'DBCOLLECTOR') {
      return data?.collectors && data?.collectors.length > 0 ?
        data.collectors.map((i) => (i.clientCode ? i.clientCode : i)) :
        [];
    } else if (selectedAccessMethod === 'DSDISP') {
      return data?.disposition && data?.disposition.length > 0 ?
        data.disposition.map((i) => {
          return i.valueCode;
        }) :
        [];
    } else if (selectedAccessMethod === 'DBCLNT') {
      return data?.client && data?.client.length > 0 ?
        data.client.map((i) => (i.clientCode ? i.clientCode : i)) :
        [];
    } else if (selectedAccessMethod === 'DSSTAT') {
      return data?.phase && data?.phase.length > 0 ? data.phase.map((i) => i?.valueCode) : [];
    } else if (selectedAccessMethod === 'DBUDWFIELDS') {
      return data?.values && data?.values.length > 0 ?
        data.values.map((i) => {
          if (data?.fieldsName?.fieldType?.toLowerCase() === 'date') {
            return getValue(i);
          } else {
            return i;
          }
        }) :
        [];
    } else {
      return [];
    }
  };
  useEffect(() => {
    (fieldCodeValue?.fieldCode ||
      initialValue?.accessMethod?.fieldCode ||
      triggerData?.accessType) &&
      dispatch(
        getActions(
          fieldCodeValue?.fieldCode ?
            fieldCodeValue?.fieldCode :
            initialValue?.accessMethod?.fieldCode ?
              initialValue?.accessMethod?.fieldCode :
              triggerData?.accessType,
        ),
      );
  }, [fieldCodeValue?.fieldCode, initialValue?.accessMethod?.fieldCode, triggerData?.accessType]);
  const handleSubmit = (data) => {
    const accessMethodRequestData = {
      accessMethod: data?.accessMethod?.fieldCode ? data?.accessMethod?.fieldCode : '',
      endDate:
          data?.action === '>' && !['Is Blank', 'Is Not Blank']?.includes(data?.action) ?
            data?.Date ? // ? getFormattedDate(data?.Date)
              getValue(data?.Date) :
              data?.accessMethod?.fieldCode === 'DBLSTDTE' &&
                data?.lastDate &&
                !['Is Blank', 'Is Not Blank']?.includes(data?.action) :
            data?.accessMethod?.fieldCode === 'DBLSTDTE' &&
              data?.lastDate &&
              !['Is Blank', 'Is Not Blank']?.includes(data?.action) ? // ? getFormattedDate(data?.lastDate)
              getValue(data?.lastDate) :
              '',
      action: data?.action ? data?.action : '',
      startDate:
          data?.action === '<' && !['Is Blank', 'Is Not Blank']?.includes(data?.action) ?
            data?.Date ? // ? getFormattedDate(data?.Date)
              getValue(data?.Date) :
              data?.accessMethod?.fieldCode === 'DBLSTDTE' &&
                data?.startDate &&
                !['Is Blank', 'Is Not Blank']?.includes(data?.action) :
            data?.accessMethod?.fieldCode === 'DBLSTDTE' &&
              data?.startDate &&
              !['Is Blank', 'Is Not Blank']?.includes(data?.action) ? // ? getFormattedDate(data?.startDate)
              getValue(data?.startDate) :
              '',
      value:
          data?.accessMethod?.fieldCode === 'DBLSTDTE' ||
          ['Is Blank', 'Is Not Blank', 'BETWEEN', 'NOT BETWEEN']?.includes(data?.action) ?
            [] :
            getArrayData(data?.accessMethod?.fieldCode, data),
      repositoryName:
          data?.accessMethod?.fieldCode === 'DBLSTDTE' ||
          ['Is Blank', 'Is Not Blank']?.includes(data?.action) ?
            data?.repoitoryName?.repositoryName :
            data?.repoitoryName?.repositoryName ?
              data?.repoitoryName?.repositoryName :
              '',
      fieldName:
          data?.accessMethod?.fieldCode === 'DBLSTDTE' ||
          ['Is Blank', 'Is Not Blank']?.includes(data?.action) ?
            data?.fieldsName?.fieldName :
            data?.fieldsName?.fieldName ?
              data?.fieldsName?.fieldName :
              '',
      fromValue:
          data?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
          ['BETWEEN', 'NOT BETWEEN']?.includes(data?.action) &&
          data?.fromValues ?
            data?.fieldsName?.fieldType?.toLowerCase() === 'date' ?
              getValue(data?.fromValues) :
              data?.fromValues :
            '',
      toValue:
          data?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
          ['BETWEEN', 'NOT BETWEEN']?.includes(data?.action) &&
          data?.toValues ?
            data?.fieldsName?.fieldType?.toLowerCase() === 'date' ?
              getValue(data?.toValues) :
              data?.toValues :
            '',
    };
    let updatedRunTaskData;
    if (data?.taskType?.value === 'Run Report') {
      updatedRunTaskData = {
        accessMethodRequest: accessMethodRequestData,
        reportId: data?.reportId ?
          data?.reportId :
          reportSearchCode?.reportId ?
            reportSearchCode?.reportId :
            0,
        reportCode: data?.reportCode ?
          data?.reportCode :
          reportSearchCode?.reportCode ?
            reportSearchCode?.reportCode :
            '',
        displayHeader: data?.displayHeader ? data?.displayHeader.key : '',
        fieldSeparator: data?.fieldSeparator?.value ? data?.fieldSeparator?.value : '',
        jobId: jobDetailsData?.jobId ? jobDetailsData?.jobId : 0,
        notifyCompletionEmails: data?.notifyCompletion?.length ?
          data?.notifyCompletion?.split(',') :
          [],
        notifyErrorEmails: data?.notifyError?.length ? data?.notifyError?.split(',') : [],
        reportFormat: data?.reportFormat?.value ? data?.reportFormat?.value : '',
        reportParameterId: data?.reportParameterId ? data?.reportParameterId : 0,
        taskId: data?.taskId ? data?.taskId : 0,
        moduleName: data?.module?.value ? data?.module?.value : '',
        reportOutputFileName: data?.outputFileNameReport ? data?.outputFileNameReport : '',
        reportfolderPath: data?.reportpath ? data?.reportpath : '',
      };
    }
    const Task = {
      taskType: data?.taskType?.value ? data?.taskType?.value : '',
      continuePrevTaskFailure: data?.continuePrevTaskFailure ?
        data?.continuePrevTaskFailure?.value :
        '',
      description: '',
      jobCode: jobDataId ? jobDataId : '',
      seqNo: isEditMode ? rowEditData?.seqNo : taskData?.length + 1,
      skipOnCompletion: data?.skipOnCompletion?.value ? data?.skipOnCompletion?.value : '',
      taskCode: data?.taskCode ? data?.taskCode : '',
      taskDataManagerParameterRequest: ['Letter Batches', 'Imports', 'Exports']?.includes(
        data?.taskType?.value,
      ) ?
        {} :
        {
          dmParameterId: 0,
          jobId: jobDetailsData?.jobId ? jobDetailsData?.jobId : 0,
          taskId: data?.taskId ? data?.taskId : 0,
          triggerGroupCode: '',
        },
      taskId: data?.taskId ? data?.taskId : 0,
      // taskLetterGroupCode:[],
      taskReportParameterRequest: ['Run Report']?.includes(data?.taskType?.value) ?
        updatedRunTaskData :
        {},
      taskTriggerGroupParameterRequest: ['Trigger Group']?.includes(data?.taskType?.value) ?
        {
          accessMethodRequest: accessMethodRequestData,
          jobId: jobDetailsData?.jobId ? jobDetailsData?.jobId : 0,
          taskId: data?.taskId ? data?.taskId : 0,
          triggerGroupCode: data?.triggerGroupCode ?
            data?.triggerGroupCode :
            triggerSearchCode?.groupCode ?
              triggerSearchCode?.groupCode :
              '',
          triggerGroupParameterId: data?.triggerGroupParameterId ?
            data?.triggerGroupParameterId :
            0,
        } :
        {},
      taskLetterGroupParameterRequest: ['Letter Batches']?.includes(data?.taskType?.value) ?
        {
          jobId: jobDetailsData?.jobId ? jobDetailsData?.jobId : 0,
          letterGroupCode:
                data?.taskType?.value === 'Trigger Group' || data?.taskType?.value === 'Run Report' ?
                  [] :
                  data?.letterGroupCode?.length > 0 ?
                    data?.letterGroupCode?.map((el) => el?.letterGroupCode) :
                    [],
          letterGroupParameterId: data?.letterGroupParameterId ?
            data?.letterGroupParameterId :
            0,
          taskId: data?.taskId ? data?.taskId : 0,
          letterType: data?.letterType?.value ? data?.letterType?.value : '',
        } :
        {},
      taskImportParameterRequest: ['Imports']?.includes(data?.taskType?.value) ?
        {
          clientCode: data?.clientCode?.clientNumber ? data?.clientCode?.clientNumber : '',
          outputFileName: data?.outputFileName ? data?.outputFileName : '',
          importCode: data?.dmCode ? data?.dmCode : '',
          importParameterId: data?.importParameterId ? data?.importParameterId : 0,
          jobId: jobDetailsData?.jobId ? jobDetailsData?.jobId : 0,
          taskId: data?.taskId ? data?.taskId : 0,
          folderPath: data?.reportpathDm ? data?.reportpathDm : '',
        } :
        {},
      taskExportParameterReqeust: ['Exports']?.includes(data?.taskType?.value) ?
        {
          clientCode:
                data?.clientCode?.length > 0 ? data?.clientCode?.map((el) => el?.clientNumber) : [],
          endDate: data?.endTime ? getValue(data?.endTime) : '',
          exportCode: data?.dmCode ? data?.dmCode : '',
          exportParameterId: data?.exportParameterId ? data?.exportParameterId : 0,
          startDate: data?.startTime ? getValue(data?.startTime) : '',
          jobId: jobDetailsData?.jobId ? jobDetailsData?.jobId : 0,
          taskId: data?.taskId ? data?.taskId : 0,
          exportFormatType: data?.exportFormat?.value ? data?.exportFormat?.value : '',
          clientIdPrompt: data?.clientIdPrompt ? data?.clientIdPrompt : '',
          auditDatesPrompt: data?.auditDatesPrompt ? data?.auditDatesPrompt : '',
          folderPath: data?.reportpathDm ? data?.reportpathDm : '',
          outputFileName: data?.outputFileName ? data?.outputFileName : '',
        } :
        {},
    };
    if (isEditMode) {
      const updatedTasks = taskData?.map((each) => {
        if (
          each?.taskId && data?.taskId ?
            each?.taskId === data?.taskId :
            each?.taskCode === data?.taskCode
        ) {
          return {
            ...each,
            ...Task,
          };
        }
        return each;
      });
      setTaskData(updatedTasks);
    } else {
      setTaskData([...taskData, Task]);
    }
    handleClose();
    setReportData({});
    setTask(true);
    isActionChanged.current = false;
  };
  useEffect(() => {
    dispatch(getFieldCode());
    dispatch(getClientCodeData());
    dispatch(getExportFormatType());
  }, []);

  useEffect(() => {
    if (DmtableData?.dmCode) {
      const exportFormatVal =
        DmtableData?.exportFormatType ?
          getValueObject(DmtableData?.exportFormatType, EXPORT_FORMAT_TYPE, exportFormatTypeData) :
          '';
      const clientIDPromptVal =
        // rowEditData?.taskExportParameterReqeust?.clientIdPrompt
        // ? rowEditData?.taskExportParameterReqeust?.clientIdPrompt
        //   :
        DmtableData?.clientIdPrompt ? DmtableData?.clientIdPrompt : '';
      const DmCodeVal =
        // isEditMode && ["Exports"]?.includes(rowEditData?.taskType)
        //   ?
        // rowEditData?.taskExportParameterReqeust?.exportCode
        // :
        DmtableData?.dmCode ? DmtableData?.dmCode : '';
      const auditDatesPromptVal = DmtableData?.auditDatesPrompt ?
        DmtableData?.auditDatesPrompt :
        '';
      const outputFileName = basicInfoData?.reportOutputFileName ?
        basicInfoData?.reportOutputFileName :
        '';
      const exportfolderPath = basicInfoData?.exportfolderPath ?
        basicInfoData?.exportfolderPath :
        '';
      setInitialValue((prev) => ({
        ...prev,
        clientIdPrompt: clientIDPromptVal,
        dmCode: DmCodeVal,
        exportFormat: exportFormatVal,
        auditDatesPrompt: auditDatesPromptVal,
        startTime: '',
        endTime: '',
        clientCode: [],
        reportpathDm: exportfolderPath,
        outputFileName: outputFileName,
      }));
      // setFieldValue("dmCode", DmtableData?.dmCode);
    }
  }, [DmtableData, isEditMode, basicInfoData, additionalInfoData]);

  useEffect(() => {
    if (reportData?.reportCode) {
      const reportoutputFileNameReport = additionalInfoData?.reportOutputFileName ?
        additionalInfoData?.reportOutputFileName :
        '';

      const reportfolderPath = additionalInfoData?.reportfolderPath ?
        additionalInfoData?.reportfolderPath :
        '';
      setInitialValue((prev) => ({
        ...prev,
        reportpath: reportfolderPath,
        outputFileNameReport: reportoutputFileNameReport,
      }));
    }
  }, [reportData, additionalInfoData]);
  // useEffect(() => {
  //   dispatch(getLetterDropDownData());
  // }, []);

  useEffect(() => {
    initialValue?.accessMethod?.fieldCode &&
      dispatch(
        postFieldCode({
          fieldCode: initialValue?.accessMethod?.fieldCode,
          options: initialValue?.action,
        }),
      );
  }, [initialValue]);
  const getActionsValues = (type, dropdownData) => {
    if (['amount', 'number', 'date']?.includes(type?.toLowerCase())) {
      return dropdownData?.length > 0 ? dropdownData : [];
    } else {
      const data =
        dropdownData?.length > 0 ?
          dropdownData?.filter((el) => !['BETWEEN', 'NOT BETWEEN']?.includes(el)) :
          [];
      return data;
    }
  };
  window.onclick = function() {
    setNamePopover(false);
    setNamePopover1(false);
    setCodePopover(false);
  };
  return (
    <Formik
      onSubmit={(values) => handleSubmit(values)}
      initialValues={initialValue}
      validationSchema={schema}
      enableReinitialize
      innerRef={formRef}
    >
      {(props) => {
        const {
          values,
          handleChange,
          setFieldValue,
          handleBlur,
          touched,
          errors,
          dirty,
        } = props;
        return (
          <>
            {reportSearch ? (
              <div className="new-standard-textfields">
                <Button
                  variant="text"
                  className={'mb-3 ml-4 search-btn'}
                  onClick={() => {
                    setReportSearch(false);
                  }}
                >
                  <ArrowBack className="mr-2" />
                  Go Back
                </Button>
                {values?.module?.value === 'Report' ? (
                  <ReportMasterSearch
                    reportMasterSearch={true}
                    setReportSearchCode={setReportSearchCode}
                    setReportSearch={setReportSearch}
                    setReportData={setReportData}
                    // handleReportSearch={handleReportSearch}
                  />
                ) : values?.module?.value === 'WorkQueue' ? (
                  <WorkQueueSearch
                    reportMasterSearch={true}
                    setReportSearchCode={setReportSearchCode}
                    setReportSearch={setReportSearch}
                    setReportData={setReportData}
                    setModuleValue={setFieldValue}
                    // handleReportSearch={handleReportSearch}
                  />
                ) : null}
              </div>
            ) : searchTrigger ? (
              <div className="new-standard-textfields">
                <Button
                  variant="text"
                  className={`mb-3 ml-3 search-btn`}
                  onClick={() => {
                    setSearchTrigger(false);
                  }}
                >
                  <ArrowBack className="mr-2" />
                  Go Back
                </Button>
                <TriggerSearchTrigger
                  nightJobSearchTrigger={true}
                  setTriggerSearchCode={setTriggerSearchCode}
                  setSearchTrigger={setSearchTrigger}
                  seTriggerData={seTriggerData}
                  // handleTriggerGroup={handleTriggerGroup}
                />
              </div>
            ) : isCodeSearch ? (
              <div className="new-standard-textfields">
                <Button
                  variant="text"
                  className={`mb-3 ml-3 search-btn`}
                  onClick={() => {
                    setIsCodeSearch(false);
                  }}
                >
                  <ArrowBack className="mr-2" />
                  Go Back
                </Button>
                <DataManagerSearch
                  isSchedular={true}
                  setDMCode={setFieldValue}
                  setIsCodeSearch={setIsCodeSearch}
                  exportManager={Boolean(values.taskType?.value === 'Exports')}
                  setDmTableData={setDmTableData}
                />
              </div>
            ) : (
              <div className={classes.addRule}>
                <div className={classes.dialoguecardStyles}>
                  <div>
                    <Form
                      autoComplete="off"
                      noValidate
                      // onSubmit={handleSubmit}
                      // onReset={handleReset}
                    >
                      <div>
                        <ErrorBoundaryForComponents>
                          <Grid
                            container
                            className="global-field-textfields new-standard-textfields"
                            spacing={2}
                          >
                            <Grid
                              item
                              xs={4}
                              className={`form-group ${componentClasses.popUpValidation}`}
                            >
                              <TextField
                                margin="dense"
                                variant="outlined"
                                className={`${classes.labelName}`}
                                placeholder={`Enter Task Code`}
                                label="Task Code"
                                disabled={isEditMode}
                                // className={` ${classes.labelName} ${classes.inputLabel}`}
                                // InputLabelProps={{
                                //   shrink: true,
                                // }}
                                name="taskCode"
                                required
                                value={values?.taskCode}
                                onChange={(e) => {
                                  setCurrentRuleCode(e.target.value);
                                  handleChange(e);
                                  if (e.target.value) {
                                    setCodePopover(true);
                                  } else if (e.target.value === '') {
                                    setCodePopover(false);
                                  }
                                }}
                                onBlur={handleBlur}
                                fullWidth
                                touched={touched.taskCode}
                                error={Boolean(touched.taskCode && errors.taskCode)}
                              />
                              <FormHelperText>
                                {touched.taskCode && errors.taskCode && errors.taskCode}
                              </FormHelperText>
                              <div className="windowcode-popover Add-trigger-group-popover">
                                {codePopover &&
                                  getTaskCodesData()?.map((data, i) => (
                                    <MenuItem key={i}>{data?.taskCode}</MenuItem>
                                  ))}
                              </div>
                            </Grid>
                            <Grid item xs={4} className="form-group">
                              <GuiAutoComplete
                                classes={{
                                  option: classes.option,
                                }}
                                name="taskType"
                                id="taskType"
                                className={`${classes.labelName}`}
                                size="small"
                                value={values?.taskType}
                                getOptionLabel={(option) => {
                                  return option && option?.value ? option?.value : '';
                                }}
                                options={taskTypes}
                                disabled={isEditMode}
                                required
                                onChange={(e, value) => {
                                  setReportData({});
                                  setFieldValue('taskType', value);
                                  setDmTableData({});
                                  dispatch(resetDataManager());
                                  dispatch(resetReportMasterData());
                                  resetTaskParameters();
                                }}
                                renderInput={(params) => (
                                  <div className="select-field">
                                    <GuiTextField
                                      {...params}
                                      error={Boolean(touched.taskType && errors.taskType)}
                                      variant="outlined"
                                      className={`${classes.labelName}`}
                                      margin="dense"
                                      // InputLabelProps={{
                                      //   shrink: true,
                                      // }}
                                      required
                                      label="Task Type"
                                      name="taskType"
                                      placeholder="Select Task Type"
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: 'off',
                                      }}
                                      // className={` ${classes.labelName} ${classes.selectLabel}`}
                                    />
                                  </div>
                                )}
                              />
                              <FormHelperText>
                                {touched.taskType && errors.taskType && errors.taskType}
                              </FormHelperText>
                            </Grid>
                            {values.taskType?.value === 'Run Report' ? (
                              <Grid item xs={12}>
                                <div className={`${componentClasses.taskParameters}`}>
                                  <Typography variant="h4" className={classes.legend}>
                                    Task Parameters{' '}
                                  </Typography>
                                  <Grid container spacing={2} className="new-standard-textfields">
                                    <>
                                      <Grid item sm={6} md={4} xl={4} className={`form-group `}>
                                        <GuiAutoComplete
                                          classes={{
                                            option: classes.option,
                                          }}
                                          id="module"
                                          size="small"
                                          autoHighlight
                                          value={values?.module}
                                          options={moduleType}
                                          disabled={isEditMode}
                                          getOptionLabel={(option) => {
                                            return option?.value ? option?.value : '';
                                          }}
                                          onChange={(_, data) => {
                                            setFieldValue('module', data);
                                            if (!isEditMode) {
                                              setReportData({});
                                              resetTaskParameters();
                                              setReportSearchCode({});
                                              setNamePopover(false);
                                              dispatch(resetReportMasterData());
                                            }
                                          }}
                                          renderInput={(params) => (
                                            <div className="select-field">
                                              <GuiTextField
                                                className={` ${classes.labelName}`}
                                                {...params}
                                                variant="outlined"
                                                fullWidth
                                                label="Module Type"
                                                error={Boolean(touched.module && errors.module)}
                                                name="module"
                                                required
                                                placeholder="Select Module Type"
                                                inputProps={{
                                                  ...params.inputProps,
                                                  autoComplete: 'off',
                                                }}
                                              />
                                            </div>
                                          )}
                                        />
                                        <FormHelperText variant="outlined">
                                          {touched.module && errors.module && errors.module}
                                        </FormHelperText>
                                      </Grid>

                                      <Grid item xs={4} className="form-group" autoComplete="off">
                                        <TextField
                                          margin="dense"
                                          className={`${classes.labelName}`}
                                          id="reportCode"
                                          variant="outlined"
                                          placeholder={`Enter ${
                                            values?.module?.value === 'Report' ?
                                              'Report' :
                                              'WorkQueue'
                                          } Name`}
                                          label={`${
                                            values?.module?.value === 'Report' ?
                                              'Report' :
                                              'WorkQueue'
                                          } Name`}
                                          value={values?.reportCode}
                                          inputRef={codeRef}
                                          disabled={isEditMode}
                                          name="reportCode"
                                          // onClick={() => {
                                          //   setNamePopover(!namePopover);
                                          // }}
                                          onChange={(e) => {
                                            handleChange(e);
                                            // const value = upperCaseCode(codeRef);
                                            // setNamePopover(true);
                                            setFieldValue('reportCode', e?.target?.value);
                                            getReportData(e?.target?.value, values?.module?.value);
                                            if (e.target.value) {
                                              setNamePopover(true);
                                              setNameData(e?.target?.value);
                                            } else if (e.target.value === '') {
                                              setNamePopover(false);
                                            }
                                          }}
                                          // className={` ${classes.labelName} ${classes.inputLabel}`}
                                          // InputLabelProps={{
                                          //   shrink: true,
                                          // }}
                                          required
                                          InputProps={{
                                            endAdornment: (
                                              // Added tooltip (2700430604)
                                              <InputAdornment position="end">
                                                <Tooltip title={'Search'}>
                                                  <Search
                                                    className={` ${classes.iconSearch}`}
                                                    onClick={() => setReportSearch(true)}
                                                    size="sm"
                                                  />
                                                </Tooltip>
                                                <Tooltip title={'Clear'}>
                                                  <Clear
                                                    className={` ${classes.iconSearch}`}
                                                    // Clear Event Trigger data(2700430604)
                                                    onClick={(e) => {
                                                      setReportData({});
                                                      resetTaskParameters();
                                                      setReportSearchCode({});
                                                      setNamePopover(false);
                                                    }}
                                                  />
                                                </Tooltip>
                                              </InputAdornment>
                                            ),
                                          }}
                                          // value={values?.taskCode?.toUpperCase()}
                                          // onChange={(e) => {
                                          //   setCurrentRuleCode(e.target.value);
                                          //   handleChange(e);
                                          // }}
                                          onBlur={handleBlur}
                                          fullWidth
                                          // touched={touched.taskCode}
                                          error={Boolean(touched.reportCode && errors.reportCode)}
                                        />
                                        <FormHelperText>
                                          {touched.reportCode &&
                                            errors.reportCode &&
                                            errors.reportCode}
                                        </FormHelperText>
                                        {/* {namePopover && getReportsPopOverData()?.length > 0 && (
                                          <div
                                            ref={ref}
                                            className={`pt-2 pb-2 windowcode-popover Add-trigger-group-popover data-repo-popover-width ${
                                              namePopover ? "popover-open" : ""
                                            }`}
                                          >
                                            {namePopover && (
                                              <ViewportList
                                                viewportRef={ref}
                                                items={getReportsPopOverData()}
                                                itemMinSize={10}
                                              >
                                                {(item) => (
                                                  <div
                                                    className="data-repo-popover"
                                                    key={item?.reportCode}
                                                  >
                                                    <p
                                                      className={`${
                                                        selectedOption === item?.reportCode
                                                          ? "selected-dropdown-option"
                                                          : ""
                                                      }`}
                                                      onClick={() => {
                                                        setFieldValue(
                                                          "reportCode",
                                                          item?.reportCode
                                                        );
                                                        setSelectedOption(item?.reportCode);
                                                        getReportData(
                                                          item?.reportCode,
                                                          allRecordCodes
                                                        );
                                                        setNamePopover(false);
                                                      }}
                                                    >
                                                      {item?.reportCode}
                                                    </p>
                                                  </div>
                                                )}
                                              </ViewportList>
                                            )}
                                          </div>
                                        )} */}
                                        <div className="windowcode-popover Add-trigger-group-popover">
                                          {namePopover &&
                                            getReportsPopOverData(values?.module?.value)?.map(
                                              (data) => (
                                                <MenuItem key={data?.reportCode}>
                                                  {data?.reportCode}
                                                </MenuItem>
                                              ),
                                            )}
                                        </div>
                                      </Grid>

                                      <Grid item sm={6} md={4} xl={4} className={`form-group `}>
                                        <GuiAutoComplete
                                          classes={{
                                            option: classes.option,
                                          }}
                                          name="accessMethod"
                                          id="accessMethod"
                                          size="small"
                                          value={values?.accessMethod}
                                          options={fieldCodeData}
                                          getOptionDisabled={(option) => option.valueCode === null}
                                          getOptionLabel={(option) => {
                                            return option && option?.fieldCode ?
                                              option?.description :
                                              '';
                                          }}
                                          required
                                          onChange={(_, data) => {
                                            setFieldCodeValue(data);
                                            setFieldValue('accessMethod', data);
                                            setFieldValue(
                                              'action',
                                              !['DBLSTDTE', 'DBACCT'].includes(data?.fieldCode) ?
                                                'IN' :
                                                '',
                                            );
                                            data?.fieldCode &&
                                              dispatch(
                                                postFieldCode({
                                                  fieldCode: data?.fieldCode,
                                                  options: values?.action,
                                                }),
                                              );
                                            if (
                                              !['DBLSTDTE', 'DBACCT'].includes(data?.fieldCode) &&
                                              data?.fieldCode
                                            ) {
                                              dispatch(
                                                postFieldCode({
                                                  fieldCode: data?.fieldCode,
                                                  options: 'IN',
                                                }),
                                              );
                                            }
                                          }}
                                          // InputLabelProps={{
                                          //   shrink: true,
                                          // }}
                                          renderInput={(params) => (
                                            <div className="select-field">
                                              <GuiTextField
                                                className={`${classes.labelName}`}
                                                {...params}
                                                variant="outlined"
                                                margin="dense"
                                                fullWidth
                                                label="Filter Method"
                                                name="accessMethod"
                                                required
                                                // InputLabelProps={{
                                                //   shrink: true,
                                                // }}
                                                error={Boolean(
                                                  touched.accessMethod && errors.accessMethod,
                                                )}
                                                onBlur={handleBlur}
                                                placeholder="Select Filter Method"
                                                inputProps={{
                                                  ...params.inputProps,
                                                  autoComplete: 'off',
                                                }}
                                              />
                                            </div>
                                          )}
                                        />
                                        <FormHelperText style={{color: 'red'}} variant="outlined">
                                          {touched?.accessMethod && errors && errors?.accessMethod}
                                        </FormHelperText>
                                      </Grid>
                                      {values?.accessMethod?.fieldCode === 'DBUDWFIELDS' && (
                                        <>
                                          <Grid item sm={6} md={4} lg={4} className="form-group">
                                            <FormControl
                                              margin="dense"
                                              variant="outlined"
                                              fullWidth
                                            >
                                              <GuiAutoComplete
                                                classes={{
                                                  option: classes.option,
                                                }}
                                                name={'repoitoryName'}
                                                size="small"
                                                onBlur={handleBlur}
                                                value={values?.repoitoryName || ''}
                                                getOptionLabel={(option) => {
                                                  return option && option?.repositoryName ? option?.repositoryName : '';
                                                }}
                                                onChange={(_, data) => {
                                                  isActionChanged.current = true;
                                                  setFieldValue('repoitoryName', data);
                                                  setFieldValue('action', 'IN');
                                                  setFieldValue('fieldsName', '');
                                                  if (values?.accessMethod?.fieldCode) {
                                                    dispatch(
                                                      postFieldCode({
                                                        fieldCode: values?.accessMethod?.fieldCode,
                                                        options: 'IN',
                                                      }),
                                                    );
                                                  }
                                                  data?.repositoryName ?
                                                    dispatch(fetchUserDefinedFields(data?.repositoryName)) :
                                                    null;
                                                }}
                                                options={userDefinedWindowData}
                                                renderInput={(params) => (
                                                  <div className="select-field">
                                                    <GuiTextField
                                                      className={` ${classes.labelName}`}
                                                      {...params}
                                                      variant="outlined"
                                                      margin="dense"
                                                      label={'Repository Name'}
                                                      required
                                                      error={Boolean(
                                                        touched?.repoitoryName &&
                                                          errors?.repoitoryName,
                                                      )}
                                                      placeholder={'Repository Name'}
                                                    />
                                                  </div>
                                                )}
                                              />
                                            </FormControl>
                                            <FormHelperText
                                              style={{color: 'red'}}
                                              variant="outlined"
                                            >
                                              {touched?.repoitoryName &&
                                                errors?.repoitoryName &&
                                                errors?.repoitoryName}
                                            </FormHelperText>
                                          </Grid>
                                          <Grid item sm={6} md={4} lg={4} className="form-group">
                                            <FormControl
                                              margin="dense"
                                              variant="outlined"
                                              fullWidth
                                            >
                                              <GuiAutoComplete
                                                classes={{
                                                  option: classes.option,
                                                }}
                                                name={'fieldsName'}
                                                size="small"
                                                onBlur={handleBlur}
                                                value={values?.fieldsName || ''}
                                                onChange={(e, value) => {
                                                  isActionChanged.current = true;
                                                  setFieldValue('action', 'IN');
                                                  setFieldValue('fieldsName', value);
                                                  if (values?.accessMethod?.fieldCode) {
                                                    dispatch(
                                                      postFieldCode({
                                                        fieldCode: values?.accessMethod?.fieldCode,
                                                        options: 'IN',
                                                      }),
                                                    );
                                                  }
                                                }}
                                                options={userDefinedFieldsData}
                                                getOptionLabel={(option) => {
                                                  return option && option?.fieldName ?
                                                    option.fieldName :
                                                    '';
                                                }}
                                                renderInput={(params) => (
                                                  <div className="select-field">
                                                    <GuiTextField
                                                      className={` ${classes.labelName}`}
                                                      {...params}
                                                      variant="outlined"
                                                      margin="dense"
                                                      required
                                                      error={Boolean(
                                                        touched?.fieldsName && errors?.fieldsName,
                                                      )}
                                                      label={'Field Name'}
                                                      placeholder={'Enter Field Name'}
                                                    />
                                                  </div>
                                                )}
                                              />
                                            </FormControl>
                                            <FormHelperText
                                              style={{color: 'red'}}
                                              variant="outlined"
                                            >
                                              {touched?.fieldsName &&
                                                errors?.fieldsName &&
                                                errors?.fieldsName}
                                            </FormHelperText>
                                          </Grid>
                                        </>
                                      )}
                                      {values?.accessMethod?.fieldCode !== 'DBACCT' &&
                                        values?.accessMethod?.fieldCode && (
                                        <>
                                          <Grid item sm={6} md={4} lg={4} className="form-group">
                                            <GuiAutoComplete
                                              classes={{
                                                option: classes.option,
                                              }}
                                              name="action"
                                              id="action"
                                              size="small"
                                              value={values?.action}
                                              options={
                                                values?.accessMethod?.fieldCode === 'DBUDWFIELDS' ?
                                                  getActionsValues(
                                                    values?.fieldsName?.fieldType,
                                                    actionData,
                                                  ) :
                                                  actionData
                                              }
                                              disabled={fieldCodeValue?.fieldCode === 'DBACCT'}
                                              getOptionLabel={(option) => {
                                                return option ? option : '';
                                              }}
                                              required
                                              onChange={(_, data) => {
                                                setFieldValue('action', data);
                                                isActionChanged.current = true;
                                                setSubmitted && setSubmitted(false);
                                                values?.accessMethod?.fieldCode &&
                                                    data &&
                                                    dispatch(
                                                      postFieldCode({
                                                        fieldCode: values?.accessMethod?.fieldCode,
                                                        options: data,
                                                      }),
                                                    );
                                              }}
                                              // InputLabelProps={{
                                              //   shrink: true,
                                              // }}
                                              renderInput={(params) => (
                                                <div className="select-field">
                                                  <GuiTextField
                                                    margin="dense"
                                                    className={`${classes.labelName}`}
                                                    {...params}
                                                    variant="outlined"
                                                    // InputLabelProps={{
                                                    //   shrink: true,
                                                    // }}
                                                    fullWidth
                                                    required
                                                    error={Boolean(
                                                      touched.action && errors.action,
                                                    )}
                                                    label="Action"
                                                    name="action"
                                                    placeholder="Select Action"
                                                    inputProps={{
                                                      ...params.inputProps,
                                                      autoComplete: 'off',
                                                    }}
                                                  />
                                                </div>
                                              )}
                                            />
                                            <FormHelperText
                                              style={{color: 'red'}}
                                              variant="outlined"
                                            >
                                              {touched?.action && errors && errors?.action}
                                            </FormHelperText>
                                          </Grid>
                                          {!isLoading &&
                                              values?.taskType?.value === 'Run Report' &&
                                              values?.accessMethod?.fieldCode && (
                                            <Grid
                                              item
                                              sm={6}
                                              md={12}
                                              lg={
                                                values?.accessMethod?.fieldCode ===
                                                    'DBUDWFIELDS' ?
                                                  4 :
                                                  4
                                              }
                                              className="d-flex"
                                            >
                                              <GetAccessMethodFields
                                                values={values}
                                                formProps={props}
                                                // reportData={reportData}
                                                setFieldValue={setFieldValue}
                                                accessMethodFields={promptData}
                                                // setShowRuleGroupSearch={setShowRuleGroupSearch}
                                                fieldCodeValue={fieldCodeValue}
                                                fieldSubmitted={fieldSubmitted}
                                                setSubmitted={setSubmitted}
                                                isActionChanged={isActionChanged}
                                                addTask={true}
                                                additionalInfoData={
                                                  isEditMode ?
                                                    rowEditData?.taskReportParameterRequest
                                                      ?.accessMethodRequest :
                                                    reportData?.accessMethodInfo
                                                }
                                                renderedFrom={'Run Report'}
                                                module={'scheduler'}
                                              />
                                            </Grid>
                                          )}
                                        </>
                                      )}
                                      {/* // added fields */}
                                      <Grid item sm={6} md={4} xl={4} className={`form-group `}>
                                        <GuiAutoComplete
                                          classes={{
                                            option: classes.option,
                                          }}
                                          name="displayHeader"
                                          id="displayHeader"
                                          size="small"
                                          value={values?.displayHeader}
                                          autoHighlight
                                          options={displayHeaderData}
                                          getOptionLabel={(option) => {
                                            return option && option?.value ? option?.value : '';
                                          }}
                                          onChange={(_, data) => {
                                            setFieldValue('displayHeader', data);
                                          }}
                                          // InputLabelProps={{
                                          //   shrink: true,
                                          // }}
                                          renderInput={(params) => (
                                            <div className="select-field">
                                              <GuiTextField
                                                className={`${classes.labelName}`}
                                                {...params}
                                                {...params}
                                                variant="outlined"
                                                fullWidth
                                                label="Display Header"
                                                name="displayHeader"
                                                margin="dense"
                                                error={Boolean(
                                                  touched.displayHeader && errors.displayHeader,
                                                )}
                                                required
                                                // InputLabelProps={{
                                                //   shrink: true,
                                                // }}
                                                inputProps={{
                                                  ...params.inputProps,
                                                  autoComplete: 'off',
                                                }}
                                                placeholder="Select Display Header"
                                              />
                                            </div>
                                          )}
                                        />
                                        <FormHelperText style={{color: 'red'}} variant="outlined">
                                          {touched.displayHeader &&
                                            errors.displayHeader &&
                                            errors.displayHeader}
                                        </FormHelperText>
                                      </Grid>
                                      <Grid item sm={6} md={4} xl={4} className={`form-group `}>
                                        <GuiAutoComplete
                                          classes={{
                                            option: classes.option,
                                          }}
                                          id="reportFormat"
                                          name="reportFormat"
                                          size="small"
                                          autoHighlight
                                          value={values?.reportFormat}
                                          options={
                                            fixedLength1 === 'Y' ?
                                              getOptions(
                                                FILE_TYPE,
                                                dropDownDataReportFormat,
                                              )?.filter((each) => each?.value === 'Text') :
                                              getOptions(FILE_TYPE, dropDownDataReportFormat)
                                          }
                                          getOptionDisabled={(option) =>
                                            option?.valueCode === 'none'
                                          }
                                          getOptionLabel={(option) => {
                                            return option && option?.value ?
                                              option?.valueCode === null ?
                                                option?.value :
                                                option?.valueCode + ' - ' + option?.value :
                                              '';
                                          }}
                                          onChange={(_, data) => {
                                            setFieldValue('reportFormat', data);
                                          }}
                                          renderInput={(params) => (
                                            <div className="select-field">
                                              <GuiTextField
                                                className={`${classes.labelName}`}
                                                {...params}
                                                {...params}
                                                variant="outlined"
                                                margin="dense"
                                                fullWidth
                                                label="Report Output Format"
                                                name="reportFormat"
                                                required
                                                // InputLabelProps={{
                                                //   shrink: true,
                                                // }}
                                                error={Boolean(
                                                  touched.reportFormat && errors.reportFormat,
                                                )}
                                                inputProps={{
                                                  ...params.inputProps,
                                                  autoComplete: 'off',
                                                }}
                                                placeholder="Select Report Output Format"
                                              />
                                            </div>
                                          )}
                                        />
                                        <FormHelperText>
                                          {touched.reportFormat &&
                                            errors.reportFormat &&
                                            errors.reportFormat}
                                        </FormHelperText>
                                      </Grid>

                                      {/* {initialValues?.fixedLength !== "Y" && fixedlength === "N" && ( */}
                                      {values?.reportFormat?.value !== 'Excel' && (
                                        <Grid item sm={6} md={4} xl={4} className={` form-group `}>
                                          <GuiAutoComplete
                                            classes={{
                                              option: classes.option,
                                            }}
                                            id="fieldSeparator"
                                            name="fieldSeparator"
                                            size="small"
                                            value={values?.fieldSeparator}
                                            autoHighlight
                                            options={getOptionsRecordFormatDropDown(
                                              FIELD_SEPERATOR,
                                              dropDownDataReportFormat,
                                            )}
                                            getOptionLabel={(option) => {
                                              return option && option?.value ? option?.value : '';
                                            }}
                                            onChange={(_, data) => {
                                              setFieldValue('fieldSeparator', data);
                                            }}
                                            // InputLabelProps={{
                                            //   shrink: true,
                                            // }}
                                            renderInput={(params) => (
                                              <div className="select-field">
                                                <GuiTextField
                                                  className={`${classes.labelName}`}
                                                  {...params}
                                                  variant="outlined"
                                                  margin="dense"
                                                  fullWidth
                                                  required
                                                  error={Boolean(
                                                    touched.fieldSeparator && errors.fieldSeparator,
                                                  )}
                                                  // InputLabelProps={{
                                                  //   shrink: true,
                                                  // }}
                                                  inputProps={{
                                                    ...params.inputProps,
                                                    autoComplete: 'off',
                                                  }}
                                                  label=" Field Separator"
                                                  name="fieldSeparator"
                                                  placeholder="Select Field Separator"
                                                />
                                              </div>
                                            )}
                                          />
                                          <FormHelperText
                                            style={{color: 'red'}}
                                            variant="outlined"
                                          >
                                            {touched.fieldSeparator &&
                                              errors.fieldSeparator &&
                                              errors.fieldSeparator}
                                          </FormHelperText>
                                        </Grid>
                                      )}
                                      {/*  )} */}
                                      <Grid
                                        item
                                        xs={4}
                                        className={`form-group ${
                                          values?.notifyCompletion?.length > 2 && ``
                                        }`}
                                      >
                                        <TextField
                                          className={`${classes.labelName}`}
                                          placeholder="Enter Notify Completion Emails"
                                          margin="dense"
                                          name="notifyCompletion"
                                          variant="outlined"
                                          value={values?.notifyCompletion}
                                          label="Notify Completion Emails"
                                          // InputLabelProps={{
                                          //   shrink: true,
                                          // }}
                                          // required
                                          onBlur={handleBlur}
                                          onChange={(e) => {
                                            handleChange(e);
                                            setFieldValue('notifyCompletion', e.target.value);
                                            // if (e.target.value) {
                                            //   setCodePopover(true);
                                            //   setReportCodesData(e.target.value);
                                            // } else if (e.target.value === "") {
                                            //   setCodePopover(false);
                                            // }
                                          }}
                                          // touched={touched.notifyCompletion}
                                          // error={Boolean(errors.notifyCompletion && touched.notifyCompletion)}
                                          fullWidth
                                        />
                                        <FormHelperText style={{color: 'red'}} variant="outlined">
                                          {touched.notifyCompletion && errors.notifyCompletion}
                                        </FormHelperText>
                                      </Grid>
                                      <Grid
                                        item
                                        xs={4}
                                        className={`form-group ${
                                          values?.notifyError?.length > 2 && ``
                                        }`}
                                      >
                                        <TextField
                                          className={`${classes.labelName}`}
                                          placeholder="Enter Notify Error Emails"
                                          margin="dense"
                                          name="notifyError"
                                          variant="outlined"
                                          value={values?.notifyError}
                                          label="Notify Error Emails"
                                          // InputLabelProps={{
                                          //   shrink: true,
                                          // }}
                                          // required
                                          onBlur={handleBlur}
                                          onChange={(e) => {
                                            handleChange(e);
                                            setFieldValue('notifyError', e.target.value);
                                            // if (e.target.value) {
                                            //   setCodePopover(true);
                                            //   setReportCodesData(e.target.value);
                                            // } else if (e.target.value === "") {
                                            //   setCodePopover(false);
                                            // }
                                          }}
                                          // touched={touched.notifyError}
                                          // error={Boolean(errors.notifyError && touched.notifyError)}
                                          fullWidth
                                        />
                                        <FormHelperText style={{color: 'red'}} variant="outlined">
                                          {touched.notifyError && errors.notifyError}
                                        </FormHelperText>
                                      </Grid>
                                    </>
                                    <Grid
                                      className={`col-sm-6 col-md-4 col-xl-4 form-group py-1 reportout-filed`}
                                    >
                                      <TextField
                                        className={` ${classes.labelName}`}
                                        margin="dense"
                                        variant="outlined"
                                        placeholder={`Enter ${values.module?.value} Folder Path`}
                                        label={`${values.module?.value} Folder Path`}
                                        multiline
                                        rows={2}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment
                                              style={{cursor: 'pointer'}}
                                              onClick={() => setFolderPath(true)}
                                              position="start"
                                            >
                                              <AddBoxOutlinedIcon />
                                            </InputAdornment>
                                          ),
                                        }}
                                        name={'reportpath'}
                                        value={values?.reportpath}
                                        onChange={(e) => {
                                          setFieldValue('reportpath', e.target.value);
                                        }}
                                        fullWidth
                                        touched={touched.reportpath}
                                      />
                                      <FormHelperText
                                        style={{color: 'red', paddingTop: '5px'}}
                                        variant="outlined"
                                      >
                                        {touched.reportpath &&
                                          errors.reportpath &&
                                          errors.reportpath}
                                        {''}
                                      </FormHelperText>
                                    </Grid>
                                    <Grid
                                      className={`col-sm-6 col-md-4 col-xl-4 form-group py-1 reportout-filed label-overflow`}
                                    >
                                      <TextField
                                        className={` ${classes.labelName}`}
                                        margin="dense"
                                        variant="outlined"
                                        placeholder={`Enter ${values.module?.value} Output File Name`}
                                        label={`${values.module?.value} Output File Name`}
                                        multiline
                                        rows={2}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment
                                              style={{cursor: 'pointer'}}
                                              onClick={() => setOpen1(true)}
                                              position="start"
                                            >
                                              <AddBoxOutlinedIcon />
                                            </InputAdornment>
                                          ),
                                        }}
                                        name={'outputFileNameReport'}
                                        value={values?.outputFileNameReport}
                                        onChange={(e) => {
                                          setFieldValue('outputFileNameReport', e.target.value);
                                        }}
                                        fullWidth
                                        touched={touched.outputFileNameReport}
                                      />
                                    </Grid>
                                  </Grid>
                                </div>
                              </Grid>
                            ) : (
                              ''
                            )}
                            {values.taskType?.value === 'Trigger Group' ? (
                              <Grid item xs={12}>
                                <div className={`${componentClasses.taskParameters}`}>
                                  <Typography variant="h4" className={classes.legend}>
                                    Task Parameters
                                  </Typography>

                                  <Grid container spacing={2} className="new-standard-textfields">
                                    <Grid item xs={4} className="form-group">
                                      <TextField
                                        margin="dense"
                                        variant="outlined"
                                        className={`${classes.labelName}`}
                                        placeholder={`Enter Batch trigger`}
                                        label="Batch trigger"
                                        value={values?.triggerGroupCode}
                                        inputRef={codeRef}
                                        onChange={(e) => {
                                          const value = upperCaseName(codeRef);
                                          // setNamePopover1(true);
                                          setFieldValue('triggerGroupCode', value);
                                          getTriggerData(e?.target?.value, allbatchTriggerData);
                                          if (e.target.value) {
                                            setNamePopover1(true);
                                            setNameData1(e?.target?.value);
                                          } else if (e.target.value === '') {
                                            setNamePopover1(false);
                                          }
                                        }}
                                        // className={` ${classes.labelName} ${classes.inputLabel}`}
                                        // InputLabelProps={{
                                        //   shrink: true,
                                        // }}
                                        // onClick={() => {
                                        //   setNamePopover1(!namePopover1);
                                        // }}
                                        InputProps={{
                                          endAdornment: (
                                            // Added tooltip (2700430604)
                                            <InputAdornment position="end">
                                              <Tooltip title={'Search'}>
                                                <Search
                                                  className={` ${classes.iconSearch}`}
                                                  onClick={() => setSearchTrigger(true)}
                                                  size="sm"
                                                />
                                              </Tooltip>
                                              <Tooltip title={'Clear'}>
                                                <Clear
                                                  className={` ${classes.iconSearch}`}
                                                  // Clear Event Trigger data(2700430604)
                                                  onClick={(e) => {
                                                    resetTaskParameters();
                                                    setTriggerSearchCode({});
                                                    setNamePopover1(false);
                                                  }}
                                                />
                                              </Tooltip>
                                            </InputAdornment>
                                          ),
                                        }}
                                        name="triggerGroupCode"
                                        required
                                        // value={values?.taskCode?.toUpperCase()}
                                        // onChange={(e) => {
                                        //   // setCurrentRuleCode(e.target.value);
                                        //   // handleChange(e);
                                        // }}
                                        onBlur={handleBlur}
                                        fullWidth
                                        // touched={touched.taskCode}
                                        error={Boolean(
                                          touched.triggerGroupCode && errors.triggerGroupCode,
                                        )}
                                      />
                                      <FormHelperText>
                                        {touched.triggerGroupCode &&
                                          errors.triggerGroupCode &&
                                          errors.triggerGroupCode}
                                      </FormHelperText>
                                      {/* {namePopover1 && getBatchTriggerPopOverData()?.length > 0 && (
                                        <div
                                          ref={ref}
                                          className={`pt-2 pb-2 windowcode-popover Add-trigger-group-popover data-repo-popover-width ${
                                            namePopover ? "popover-open" : ""
                                          }`}
                                        >
                                          {namePopover1 && (
                                            <ViewportList
                                              viewportRef={ref}
                                              items={getBatchTriggerPopOverData()}
                                              itemMinSize={10}
                                            >
                                              {(item) => (
                                                <div
                                                  className="data-repo-popover"
                                                  key={item?.groupCode}
                                                >
                                                  <p
                                                    className={`${
                                                      selectedOption === item?.repositoryName
                                                        ? "selected-dropdown-option"
                                                        : ""
                                                    }`}
                                                    onClick={() => {
                                                      setFieldValue(
                                                        "triggerGroupCode",
                                                        item?.groupCode
                                                      );
                                                      setSelectedOption1(item?.groupCode);
                                                      getTriggerData(
                                                        item?.groupCode,
                                                        allbatchTriggerData
                                                      );
                                                      setNamePopover1(false);
                                                    }}
                                                  >
                                                    {item?.groupCode}
                                                  </p>
                                                </div>
                                              )}
                                            </ViewportList>
                                          )}
                                        </div>
                                      )} */}
                                      <div className="windowcode-popover Add-trigger-group-popover">
                                        {namePopover1 &&
                                          getBatchTriggerPopOverData()?.map((data) => (
                                            <MenuItem key={data?.groupCode}>
                                              {data?.groupCode}
                                            </MenuItem>
                                          ))}
                                      </div>
                                    </Grid>
                                    <Grid
                                      item
                                      sm={6}
                                      md={4}
                                      xl={4}
                                      // className={`form-group ${classes.labelName} ${classes.selectdropdown}`}
                                    >
                                      <GuiAutoComplete
                                        classes={{
                                          option: classes.option,
                                        }}
                                        name="accessMethod"
                                        id="accessMethod"
                                        size="small"
                                        value={values?.accessMethod}
                                        options={filteredfieldCodeData}
                                        getOptionDisabled={(option) => option.valueCode === null}
                                        getOptionLabel={(option) => {
                                          return option && option?.fieldCode ?
                                            option?.description :
                                            '';
                                        }}
                                        required
                                        onChange={(_, data) => {
                                          setFieldCodeValue(data);
                                          setFieldValue('accessMethod', data);
                                          setFieldValue(
                                            'action',
                                            !['DBLSTDTE', 'DBACCT'].includes(data?.fieldCode) ?
                                              'IN' :
                                              '',
                                          );
                                          data?.fieldCode &&
                                            dispatch(
                                              postFieldCode({
                                                fieldCode: data?.fieldCode,
                                                options: values?.action,
                                              }),
                                            );
                                          !['DBLSTDTE', 'DBACCT'].includes(data?.fieldCode) &&
                                            data?.fieldCode &&
                                            dispatch(
                                              postFieldCode({
                                                fieldCode: data?.fieldCode,
                                                options: 'IN',
                                              }),
                                            );
                                        }}
                                        // InputLabelProps={{
                                        //   shrink: true,
                                        // }}
                                        renderInput={(params) => (
                                          <div className="select-field">
                                            <GuiTextField
                                              // className={`${classes.labelName} ${classes.selectLabel}`}
                                              {...params}
                                              variant="outlined"
                                              margin="dense"
                                              fullWidth
                                              label="Filter Method"
                                              name="accessMethod"
                                              required
                                              onBlur={handleBlur}
                                              // InputLabelProps={{
                                              //   shrink: true,
                                              // }}
                                              error={Boolean(
                                                touched.accessMethod && errors.accessMethod,
                                              )}
                                              placeholder="Select Filter Method"
                                              inputProps={{
                                                ...params.inputProps,
                                                autoComplete: 'off',
                                              }}
                                            />
                                          </div>
                                        )}
                                      />
                                      <FormHelperText style={{color: 'red'}} variant="outlined">
                                        {touched?.accessMethod &&
                                          errors?.accessMethod &&
                                          errors?.accessMethod}
                                      </FormHelperText>
                                    </Grid>
                                    {values?.accessMethod?.fieldCode !== 'DBACCT' &&
                                      values?.accessMethod?.fieldCode && (
                                      <>
                                        <Grid item sm={6} md={3} lg={4} className="form-group">
                                          <GuiAutoComplete
                                            classes={{
                                              option: classes.option,
                                            }}
                                            name="action"
                                            id="action"
                                            size="small"
                                            value={values?.action}
                                            options={actionData}
                                            disabled={fieldCodeValue?.fieldCode === 'DBACCT'}
                                            getOptionLabel={(option) => {
                                              return option ? option : '';
                                            }}
                                            required
                                            onChange={(_, data) => {
                                              setFieldValue('action', data);
                                              isActionChanged.current = true;
                                              setSubmitted && setSubmitted(false);
                                              values?.accessMethod?.fieldCode &&
                                                  data &&
                                                  dispatch(
                                                    postFieldCode({
                                                      fieldCode: values?.accessMethod?.fieldCode,
                                                      options: data,
                                                    }),
                                                  );
                                            }}
                                            // InputLabelProps={{
                                            //   shrink: true,
                                            // }}
                                            renderInput={(params) => (
                                              <div className="select-field">
                                                <GuiTextField
                                                  margin="dense"
                                                  className={`  ${classes.actionField}`}
                                                  {...params}
                                                  variant="outlined"
                                                  // InputLabelProps={{
                                                  //   shrink: true,
                                                  // }}
                                                  fullWidth
                                                  label="Action"
                                                  name="action"
                                                  onBlur={handleBlur}
                                                  placeholder="Select Action"
                                                  required
                                                  error={Boolean(touched.action && errors.action)}
                                                  inputProps={{
                                                    ...params.inputProps,
                                                    autoComplete: 'off',
                                                  }}
                                                />
                                              </div>
                                            )}
                                          />
                                          <FormHelperText
                                            style={{color: 'red'}}
                                            variant="outlined"
                                          >
                                            {touched?.action && errors && errors?.action}
                                          </FormHelperText>
                                        </Grid>
                                        {!isLoading &&
                                            values?.taskType?.value === 'Trigger Group' &&
                                            values?.accessMethod?.fieldCode && (
                                          <Grid
                                            item
                                            sm={6}
                                            md={6}
                                            lg={
                                              values?.accessMethod?.fieldCode === 'DBUDWFIELDS' ?
                                                12 :
                                                4
                                            }
                                            className="d-flex"
                                          >
                                            <GetAccessMethodFields
                                              values={values}
                                              formProps={props}
                                              // reportData={reportData}
                                              setFieldValue={setFieldValue}
                                              accessMethodFields={promptData}
                                              // setShowRuleGroupSearch={setShowRuleGroupSearch}
                                              fieldCodeValue={fieldCodeValue}
                                              fieldSubmitted={fieldSubmitted}
                                              setSubmitted={setSubmitted}
                                              isActionChanged={isActionChanged}
                                              addTask={true}
                                              additionalInfoData={
                                                isEditMode ?
                                                  rowEditData
                                                    ?.taskTriggerGroupParameterRequest
                                                    ?.accessMethodRequest :
                                                  triggerData?.accessMethodInfo
                                              }
                                              renderedFrom={'Run Report'}
                                            />
                                          </Grid>
                                        )}
                                      </>
                                    )}
                                  </Grid>
                                </div>
                              </Grid>
                            ) : (
                              ''
                            )}
                            {values.taskType?.value === 'Letter Batches' ? (
                              <Grid item xs={12}>
                                <div className={`${componentClasses.taskParameters}`}>
                                  <Typography variant="h4" className={classes.legend}>
                                    Task Parameters
                                  </Typography>
                                  <Grid container spacing={2} className="new-standard-textfields">
                                    <>
                                      
                                      <Grid item sm={6} md={4} xl={6} className={` form-group `}>
                                        <GuiAutoComplete
                                          classes={{
                                            option: classes.option,
                                          }}
                                          name="letterType"
                                          id="letterType"
                                          className={`${classes.labelName}`}
                                          size="small"
                                          value={values.letterType}
                                          disabled={isEditMode}
                                          options={
                                            getLetterOptions(LETTER_TYPE).length > 0 ?
                                              getLetterOptions(LETTER_TYPE) :
                                              []
                                          }
                                          getOptionLabel={(option) => {
                                            return option?.value ? option?.value : '';
                                          }}
                                          onChange={(e, value) => {
                                            setFieldValue('letterType', value);
                                            setFieldValue('letterGroupCode', []);
                                            if (value?.valueCode) {
                                              dispatch(fetchAllLetterGroupCode(value?.valueCode));
                                            }
                                          }}
                                          renderInput={(params) => (
                                            <div className="select-field">
                                              <GuiTextField
                                                {...params}
                                                variant="outlined"
                                                touched={touched.letterType}
                                                error={touched.letterType && errors.letterType}
                                                margin="dense"
                                                required
                                                label="Letter Type"
                                                placeholder="Select Letter Type"
                                              />
                                            </div>
                                          )}
                                        />
                                        <FormHelperText style={{color: 'red'}}>
                                          {touched.letterType &&
                                            errors?.letterType &&
                                            errors.letterType}
                                        </FormHelperText>
                                      </Grid>
                                      <Grid item sm={6} md={4} xl={6} className={` form-group `}>
                                        <GuiAutoComplete
                                          name={'letterGroupCode'}
                                          id={'letterGroupCode'}
                                          size="small"
                                          limitTags={2}
                                          className={`${classes.labelName}`}
                                          classes={{
                                            option: classes.option,
                                            listbox: classes.listBox,
                                          }}
                                          disableCloseOnSelect
                                          disabled={!values?.letterType?.valueCode}
                                          getOptionSelected={(option, value) =>
                                            option?.letterGroupCode === value?.letterGroupCode
                                          }
                                          value={
                                            values?.letterGroupCode?.length > 0 ?
                                              values?.letterGroupCode :
                                              []
                                          }
                                          multiple
                                          onChange={(e, value) => {
                                            setFieldValue('letterGroupCode', value);
                                          }}
                                          options={allLetterGroupCode || []}
                                          autoHighlight
                                          renderOption={(option, {selected}) => {
                                            return (
                                              <React.Fragment>
                                                <>
                                                  <Checkbox
                                                    icon={icon}
                                                    checkedIcon={
                                                      <CheckBoxIcon
                                                        fontSize="small"
                                                        className="selectcheckBox"
                                                      />
                                                    }
                                                    checked={selected}
                                                  />
                                                </>
                                                {option?.letterGroupCode} -
                                                {option?.letterGroupDescription}
                                              </React.Fragment>
                                            );
                                          }}
                                          getOptionLabel={(option) => {
                                            return option?.letterGroupCode ?
                                              option?.letterGroupCode +
                                                  ' -' +
                                                  option?.letterGroupDescription :
                                              '';
                                          }}
                                          renderInput={(params) => (
                                            <div className="select-field">
                                              <GuiTextField
                                                {...params}
                                                variant="outlined"
                                                margin="dense"
                                                required
                                                error={
                                                  touched?.letterGroupCode &&
                                                  errors?.letterGroupCode
                                                }
                                                label={'Letter Group'}
                                                placeholder={`Select Letter Group`}
                                                className={`autocomplete-multiselect-label`}
                                                inputProps={{
                                                  ...params.inputProps,
                                                  autoComplete: 'off',
                                                }}
                                              />
                                            </div>
                                          )}
                                        />
                                        <FormHelperText variant="outlined">
                                          {touched?.letterGroupCode && errors?.letterGroupCode ?
                                            errors.letterGroupCode :
                                            ''}
                                        </FormHelperText>
                                      </Grid>
                                    </>
                                  </Grid>
                                </div>
                              </Grid>
                            ) : (
                              ''
                            )}
                            {['Imports', 'Exports']?.includes(values.taskType?.value) ? (
                              <Grid item xs={12}>
                                <div className={`${componentClasses.taskParameters}`}>
                                  <Typography variant="h4" className={classes.legend}>
                                    Task Parameters
                                  </Typography>
                                  <ImportExportTaskForm
                                    {...props}
                                    isCodeSearch={isCodeSearch}
                                    setIsCodeSearch={setIsCodeSearch}
                                    DmtableData={DmtableData}
                                    setDmTableData={setDmTableData}
                                  />
                                </div>
                              </Grid>
                            ) : (
                              ''
                            )}
                            <Grid
                              item
                              xs={4}
                              className={`form-group ${componentClasses.popUpValidation}`}
                            >
                              <GuiAutoComplete
                                classes={{
                                  option: classes.option,
                                }}
                                name="continuePrevTaskFailure"
                                id="continuePrevTaskFailure"
                                size="small"
                                value={values.continuePrevTaskFailure}
                                getOptionLabel={(option) => {
                                  return option && option?.key ? option?.key : '';
                                }}
                                options={options}
                                required
                                onChange={(e, value) => {
                                  setFieldValue('continuePrevTaskFailure', value);
                                }}
                                renderInput={(params) => (
                                  <div className="select-field">
                                    <GuiTextField
                                      className={` ${classes.labelName}`}
                                      {...params}
                                      error={Boolean(
                                        touched.continuePrevTaskFailure &&
                                          errors.continuePrevTaskFailure,
                                      )}
                                      variant="outlined"
                                      margin="dense"
                                      // InputLabelProps={{
                                      //   shrink: true,
                                      // }}
                                      required
                                      label="Continue on task failure"
                                      placeholder="Enter Continue on task failure"
                                    />
                                  </div>
                                )}
                              />
                              <FormHelperText>
                                {touched.continuePrevTaskFailure &&
                                  errors.continuePrevTaskFailure &&
                                  errors.continuePrevTaskFailure}
                              </FormHelperText>
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              className={`form-group  ${componentClasses.popUpValidation}`}
                            >
                              <FormControl margin="dense" variant="outlined" fullWidth>
                                <GuiAutoComplete
                                  classes={{
                                    option: classes.option,
                                  }}
                                  name="skipOnCompletion"
                                  id="skipOnCompletion"
                                  size="small"
                                  value={values.skipOnCompletion}
                                  getOptionLabel={(option) => {
                                    return option && option?.key ? option?.key : '';
                                  }}
                                  options={options}
                                  // required
                                  onChange={(e, value) => {
                                    setFieldValue('skipOnCompletion', value);
                                  }}
                                  renderInput={(params) => (
                                    <div className="select-field">
                                      <GuiTextField
                                        className={` ${classes.labelName}`}
                                        {...params}
                                        error={Boolean(
                                          touched.skipOnCompletion && errors.skipOnCompletion,
                                        )}
                                        variant="outlined"
                                        margin="dense"
                                        // InputLabelProps={{
                                        //   shrink: true,
                                        // }}
                                        required
                                        label="Skip on completion"
                                        placeholder="Select Skip on completion"
                                        // className={` ${classes.labelName} ${classes.selectLabel}`}
                                      />
                                    </div>
                                  )}
                                />
                              </FormControl>
                              <FormHelperText>
                                {touched.skipOnCompletion &&
                                  errors.skipOnCompletion &&
                                  errors.skipOnCompletion}
                              </FormHelperText>
                            </Grid>
                          </Grid>
                        </ErrorBoundaryForComponents>
                      </div>
                      <div className="d-flex justify-content-center new-standard-textfields mb-1">
                        <Button
                          variant="outlined"
                          type="reset"
                          onClick={() => {
                            handleTaskReset();
                            setSubmitted && setSubmitted(false);
                          }}
                          className={`mr-1 reset-btn ${classes.buttonRoot}`}
                        >
                          Reset
                        </Button>
                        <Button
                          variant="outlined"
                          type="submit"
                          className={`search-btn ml-1 ${classes.buttonRoot}`}
                          onClick={() => setSubmitted && setSubmitted(true)}
                        >
                          {'Add Task'}
                        </Button>
                      </div>
                      {setSample(dirty)}
                    </Form>
                  </div>
                </div>
              </div>
            )}
            {isLoading && !searchTrigger && !reportSearch && <PageLoader />}
            <DialogBox
              open={open1}
              dialogClose={handleClose1}
              hideFooter={true}
              maxWidth={'xl'}
              title={`${values.module?.value} File Name`}
            >
              <AddFileName
                setFieldValues={setFieldValue}
                setOpen={setOpen1}
                addValues={values}
                handleClose={handleClose1}
                isScheduler={true}
                moduleType={values.module?.value}
              />
            </DialogBox>
            <DialogBox
              open={folderPath}
              dialogClose={handleClose1}
              hideFooter={true}
              maxWidth={'xl'}
              title={`${values.module?.value} Folder Path`}
            >
              <ReportFolderPath
                setFieldValues={setFieldValue}
                setOpen={setOpen1}
                addValues={values}
                handleClose={handleClose1}
                folderPath={folderPath}
                isScheduler={true}
                moduleType={values.module?.value}
              />
            </DialogBox>
          </>
        );
      }}
    </Formik>
  );
};

export default TaskForm;
